import React, { useRef, useState, useEffect } from 'react';
import { ArrowUpIcon, Award, BarChart, BicepsFlexed, Building2, Check, ChevronLeft, ChevronRight, Clock, Compass, Contact, DollarSign, Facebook, Flame, Globe, HardHat, HelpCircle, Home, Image, Instagram, Layers3, Leaf, LucideMail, LucideMailCheck, Mail, MapPin, MessageSquare, Phone, Rocket, Shield, Smartphone, Speaker, SpeakerIcon, Sprout, TimerIcon, Twitter, Users, Volume, Volume2, Wrench, Zap } from 'lucide-react';
import { ReactNode } from 'react';
import { ReactComponent as Logo } from './img/logo/enprotec-logo.svg';
import logo from './img/logo/logo.png';
import './index.css';



import imagen1 from './img/carousel/1.jpeg';
import imagen2 from './img/carousel/2.jpeg';
import imagen3 from './img/carousel/3.jpeg';
import imagen4 from './img/carousel/4.jpeg';
import imagen5 from './img/carousel/5.jpeg';
import imagen6 from './img/carousel/6.jpeg';
import imagen7 from './img/carousel/7.jpeg';
import imagen8 from './img/carousel/8.jpeg';
import imagen9 from './img/carousel/9.jpeg';
import imagen10 from './img/carousel/10.jpeg';
import imagen11 from './img/carousel/11.jpeg';
import imagen12 from './img/carousel/12.jpeg';
import imagen13 from './img/carousel/13.jpeg';
import imagen14 from './img/carousel/14.jpeg';
import imagen15 from './img/carousel/15.jpeg';
import imagen16 from './img/carousel/16.jpeg';
import imagen17 from './img/carousel/17.jpeg';
import imagen18 from './img/carousel/18.jpeg';
import imagen19 from './img/carousel/19.jpeg';
import imagen20 from './img/carousel/20.jpeg'; 
import imagen21 from './img/carousel/21.jpeg';
import imagen22 from './img/carousel/22.jpeg';
import imagen23 from './img/carousel/23.jpeg';
import imagen24 from './img/carousel/24.jpeg';
import imagen25 from './img/carousel/25.jpeg';  
import imagen26 from './img/carousel/26.jpeg';
import imagen27 from './img/carousel/27.jpeg';
import imagen28 from './img/carousel/28.png';
import imagen29 from './img/carousel/29.jpg';
import imagen30 from './img/carousel/30.jpg';
import imagen31 from './img/carousel/31.png';
import imagen32 from './img/carousel/32.jpg';
import imagen33 from './img/carousel/33.png';
import imagen34 from './img/carousel/34.jpg';
import imagen35 from './img/carousel/35.png';
import imagen36 from './img/carousel/36.png';

import imgUSAEU from './img/carousel/imgUSAEU.png';


  


const WhatsAppIcon = ({ size = 24, color = 'currentColor' }: { size?: number; color?: string }) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>WhatsApp</title>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.52-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.1 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 6.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.65-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.896 6.994c-.003 5.45-4.437 9.884-9.888 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .162 5.334.16 11.888c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.88 11.88 0 005.683 1.448h.005c6.553 0 11.887-5.334 11.89-11.888a11.84 11.84 0 00-3.493-8.412"/>
  </svg>
);

const FooterQuickLinks = () => {
  // Función mejorada para scroll con animación
  const scrollToIdWithAnimation = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      // Prevenir comportamiento predeterminado si es un enlace
    
      
      // Obtener la posición del elemento
      const offsetTop = el.getBoundingClientRect().top + window.pageYOffset;
      
      // Scroll con animación
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div>
      <h3 style={{
        fontWeight: 'bold',
        color: 'white',
        marginBottom: '1.25rem',
        fontSize: '1.25rem',
        position: 'relative',
        paddingBottom: '0.75rem'
      }}>
        Enlaces Rápidos
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '2rem',
          height: '2px',
          backgroundColor: '#FBBF24'
        }}></div>
      </h3>
      {[
        { href: '#quienes-somos', label: 'Quiénes Somos', icon: <Users size={18} /> },
        { href: '#que-es-sip', label: '¿Qué es un SIP?', icon: <HelpCircle size={18} /> },
        { href: '#galeria', label: 'Galería', icon: <Image size={18} /> },
        { href: '#servicios', label: 'Servicios', icon: <HardHat size={18} /> },
        { href: '#contacto', label: 'Contacto', icon: <Mail size={18} /> }
      ].map((item, index) => (
        <a 
          key={index}
          href={item.href}
          onClick={(e) => {
            e.preventDefault();
            scrollToIdWithAnimation(item.href.substring(1));
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            color: '#E5E7EB',
            marginBottom: '0.75rem',
            textDecoration: 'none',
            transition: 'all 0.3s',
            padding: '0.5rem 0.75rem',
            borderRadius: '0.375rem',
            marginLeft: '-0.75rem'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.transform = 'translateX(0.25rem)';
            e.currentTarget.style.color = '#FBBF24';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.transform = 'translateX(0)';
            e.currentTarget.style.color = '#E5E7EB';
          }}
        >
          <span style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FBBF24'
          }}>{item.icon}</span>
          <span>{item.label}</span>
        </a>
      ))}
    </div>
  );
};

interface Proyecto {
  id: number;
  image: string;
  title: string;
  description?: string;
  category: string;
}


const GaleriaProyectos = () => {
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const [selectedImage, setSelectedImage] = useState<Proyecto | null>(null);

    
  // Datos de ejemplo - reemplazar con tus fotos reales
  // const proyectosFeatured = [
  //   { 
  //     id: 1,
  //     image: imagen1,
  //     title: 'Proyecto Residencial',
  //     description: 'Casa unifamiliar con paneles SIP en Viña del Mar. Construcción en tiempo récord de 3 meses.',
  //     category: 'Residencial'
  //   },
  //   { 
  //     id: 2,
  //     image: imagen2,
  //     title: 'Edificio Corporativo',
  //     description: 'Oficinas de 3 pisos construidas con tecnología SIP, entregando eficiencia energética clase A.',
  //     category: 'Comercial'
  //   },
  //   { 
  //     id: 3,
  //     image: imagen3,
  //     title: 'Casa Moderna',
  //     description: 'Diseño contemporáneo con eficiencia energética y aislamiento acústico premium.',
  //     category: 'Residencial'
  //   },
  //   { 
  //     id: 4,
  //     image: imagen4,
  //     title: 'Estructura SIP',
  //     description: 'Instalación de paneles estructurales para proyecto rural en la zona central.',
  //     category: 'Rural'
  //   },
  //   { 
  //     id: 5,
  //     image: imagen5,
  //     title: 'Proyecto Ecológico',
  //     description: 'Construcción sostenible certificada con huella de carbono reducida.',
  //     category: 'Sostenible'
  //   },
  //   { 
  //     id: 6,
  //     image: imagen6,
  //     title: 'Casa Prefabricada',
  //     description: 'Montaje rápido en zona rural utilizando tecnología SIP de última generación.',
  //     category: 'Prefabricado'
  //   }
  // ];
  
  // const proyectosGrid = [
  //   { id: 7, image: imagen7, title: 'Casa del Lago', category: 'Residencial' },
  //   { id: 8, image: imagen8, title: 'Oficinas Centro', category: 'Comercial' },
  //   { id: 9, image: imagen9, title: 'Eco-Cabaña', category: 'Sostenible' },
  //   { id: 10, image: imagen10, title: 'Edificio Mirador', category: 'Comercial' },
  //   { id: 11, image: imagen11, title: 'Mini Casa', category: 'Residencial' },
  //   { id: 12, image: imagen12, title: 'Casa de Montaña', category: 'Rural' },
  //   { id: 13, image: imagen13, title: 'Centro Cultural', category: 'Público' },
  //   { id: 14, image: imagen14, title: 'Vivienda Eficiente', category: 'Residencial' }
  // ];
  
  const proyectosFeatured = [
    { id: 1, image: imagen1, title: '', description: '', category: '' },
    { id: 2, image: imagen2, title: '', description: '', category: '' },
    { id: 3, image: imagen3, title: '', description: '', category: '' },
    { id: 4, image: imagen4, title: '', description: '', category: '' },
    { id: 5, image: imagen5, title: '', description: '', category: '' },
    { id: 6, image: imagen6, title: '', description: '', category: '' }
  ];
  
  const proyectosGrid = [
    { id: 7, image: imagen7, title: '', description: '', category: '' },
    { id: 8, image: imagen8, title: '', description: '', category: '' },
    { id: 9, image: imagen9, title: '', description: '', category: '' },
    { id: 10, image: imagen10, title: '', description: '', category: '' },
    { id: 11, image: imagen11, title: '', description: '', category: '' },
    { id: 12, image: imagen12, title: '', description: '', category: '' },
    { id: 13, image: imagen13, title: '', description: '', category: '' },
    { id: 14, image: imagen14, title: '', description: '', category: '' }
  ];
  
  
  
  // Autocarrusel para la galería
  useEffect(() => {
    const interval = setInterval(() => {
      if (carouselRef.current) {
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth - carouselRef.current.clientWidth - 10) {
          carouselRef.current.scrollLeft = 0;
        } else {
          carouselRef.current.scrollLeft += 320;
        }
      }
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  
  // Función para el modal

  const openModal = (proyecto: Proyecto) => {
    setSelectedImage(proyecto);
    document.body.style.overflow = 'hidden';
  };
  
  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto'; // Restaurar scroll
  };
  
  // Categorías únicas para filtros
  const categorias = ['Todas', ...Array.from(
    new Set([...proyectosFeatured, ...proyectosGrid].map(item => item.category))
  )];
    const [filtroActivo, setFiltroActivo] = useState('Todas');
  
  const proyectosFiltrados = proyectosGrid.filter(
    proyecto => filtroActivo === 'Todas' || proyecto.category === filtroActivo
  );

  return (
    <section id="galeria" style={{
      padding: '5rem 0 3rem',
      backgroundColor: '#F1F5F9'
    }}>
      <h2 style={{
        fontSize: '2.25rem',
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: '3rem',
        textAlign: 'center',
        position: 'relative',
        display: 'inline-block',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '0 1rem'
      }}>
        Galería de Proyectos
        <div style={{
          position: 'absolute',
          bottom: '-0.75rem',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '3rem',
          height: '0.25rem',
          backgroundColor: '#FBBF24',
          borderRadius: '0.25rem'
        }}></div>
      </h2>
      
      {/* Carrusel de proyectos destacados */}
      <div 
        ref={carouselRef}
        style={{
          display: 'flex',
          gap: '1.5rem',
          padding: '1.5rem',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}
      >
        {proyectosFeatured.map((proyecto) => (
          <div 
            key={proyecto.id} 
            style={{
              minWidth: '300px',
              height: '250px',
              borderRadius: '1rem',
              overflow: 'hidden',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s',
              transform: 'scale(0.95)',
              position: 'relative',
              cursor: 'pointer'
            }}
            onClick={() => openModal(proyecto)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(0.95)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
          >
            <img 
              src={proyecto.image} 
              alt={proyecto.title} 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'all 0.5s'
              }}
            />
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              color: 'white',
              padding: '1rem',
              transition: 'all 0.3s'
            }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>{proyecto.title}</h3>
              <p style={{ 
                fontSize: '0.875rem', 
                opacity: 0.9,
                maxHeight: '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s, opacity 0.3s',
              }}>{proyecto.description}</p>
              
              <div style={{
                display: 'inline-block',
                padding: '0.25rem 0.75rem',
                backgroundColor: '#FBBF24',
                color: '#F0F0F0',
                borderRadius: '1rem',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                marginTop: '0.5rem'
              }}>
                {proyecto.category}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Filtros de categoría */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '0.75rem',
        margin: '2rem 0'
      }}>
        {categorias.map((categoria) => (
          <button
            key={categoria}
            onClick={() => setFiltroActivo(categoria)}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '2rem',
              border: 'none',
              backgroundColor: filtroActivo === categoria ? '#000000' : '#E2E8F0',
              color: filtroActivo === categoria ? 'white' : '#1E293B',
              fontWeight: filtroActivo === categoria ? 'bold' : 'normal',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
          >
            {categoria}
          </button>
        ))}
      </div>
      
      {/* Cuadrícula de proyectos */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '1.5rem',
        padding: '0 1.5rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {proyectosFiltrados.map((proyecto) => (
          <div
            key={proyecto.id}
            onClick={() => openModal(proyecto)}
            style={{
              position: 'relative',
              borderRadius: '0.75rem',
              overflow: 'hidden',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s',
              aspectRatio: '1',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-0.5rem)';
              e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            }}
          >
            <img
              src={proyecto.image}
              alt={proyecto.title}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'all 0.5s'
              }}
            />
            <div style={{
              position: 'absolute',
              inset: 0,
              backgroundColor: 'rgba(30, 58, 138, 0.3)',
              transition: 'all 0.3s'
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: '1rem',
              backgroundColor: 'rgba(30, 58, 138, 0.9)',
              transform: 'translateY(100%)',
              transition: 'transform 0.3s',
              color: 'white'
            }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>{proyecto.title}</h3>
              <div style={{
                display: 'inline-block',
                padding: '0.25rem 0.5rem',
                backgroundColor: '#FBBF24',
                color: '#F0F0F0',
                borderRadius: '1rem',
                fontSize: '0.75rem',
                fontWeight: 'bold'
              }}>
                {proyecto.category}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Modal */}
      {selectedImage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '1rem'
        }} onClick={closeModal}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '1rem',
            overflow: 'hidden',
            width: '100%',
            maxWidth: '800px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              height: '400px',
              overflow: 'hidden'
            }}>
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
            <div style={{
              padding: '1.5rem'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: '#000000'
                }}>{selectedImage.title}</h3>
                <div style={{
                  display: 'inline-block',
                  padding: '0.25rem 0.75rem',
                  backgroundColor: '#FBBF24',
                  color: '#F0F0F0',
                  borderRadius: '1rem',
                  fontSize: '0.875rem',
                  fontWeight: 'bold'
                }}>
                  {selectedImage.category}
                </div>
              </div>
              <p style={{
                lineHeight: '1.6',
                color: '#4B5563'
              }}>{selectedImage.description}</p>
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '1.5rem'
              }}>
                <button
                  onClick={closeModal}
                  style={{
                    backgroundColor: '#E5E7EB',
                    color: '#1F2937',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '0.5rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

interface Servicio {
  title: string;
  description: string;
  icon: ReactNode;
  color: string;
}
interface ServicioCardProps {
  servicio: Servicio;
  index: number;
}

const ServiciosSection = () => {
  // Definir la interfaz para el tipo Servicio
  interface Servicio {
    icon: React.ReactNode;
    title: string;
    description: string;
    features: string[];
    color: string;
    bgColor: string;
  }

  const servicios: Servicio[] = [
    { 
      icon: <Layers3 size={40} />, 
      title: 'Venta y fabricación de Paneles SIP', 
      description: 'Producimos y comercializamos paneles SIP de alta calidad para proyectos residenciales y comerciales, garantizando rapidez, eficiencia energética y resistencia estructural superior.',
      features: ['Alta eficiencia térmica', 'Instalación rápida', 'Durabilidad garantizada'],
      color: '#FBBF24',
      bgColor: '#FEF3C7'
    },
    { 
      icon: <Home size={40} />, 
      title: 'Fabricación de Cerchas en Metalcon', 
      description: 'Diseñamos y fabricamos cerchas metálicas de alta resistencia, perfectas para estructuras que requieren máxima durabilidad y optimización del tiempo de construcción.',
      features: ['Estructura resistente', 'Fabricación de Paneles', 'Montaje eficiente'],
      color: '#10B981',
      bgColor: '#D1FAE5'
    },
    { 
      icon: <Compass size={40} />, 
      title: 'Montaje e instalación de obra gruesa terminada', 
      description: 'Realizamos la instalación profesional completa del Kit Básico de Obra Gruesa, asegurando una estructura sólida y eficiente con garantía de calidad.',
      features: ['Instalación profesional', 'Garantía incluida', 'Tiempo récord'],
      color: '#F59E0B',
      bgColor: '#FEE2E2'
    },
    { 
      icon: <Users size={40} />, 
      title: 'Kit básico de autoconstrucción', 
      description: 'Proveemos kits completos para autoconstrucción con todos los materiales necesarios, manuales detallados y asesoría técnica para tu proyecto.',
      features: ['Material completo', 'Guías paso a paso', 'Soporte técnico'],
      color: '#3B82F6',
      bgColor: '#DBEAFE'
    },
   
  ];

  const ServicioCard = ({ servicio, index }: { servicio: any; index: number }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    return (
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '1rem',
          padding: '1.5rem',
          boxShadow: isHovered ? '0 20px 40px rgba(0, 0, 0, 0.1)' : '0 4px 12px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease',
          transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
          border: `2px solid ${isHovered ? servicio.color : '#F3F4F6'}`,
          cursor: 'pointer',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div style={{
          width: '60px',
          height: '60px',
          backgroundColor: servicio.bgColor,
          borderRadius: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '1rem',
          color: servicio.color,
          position: 'relative',
          zIndex: 1,
          margin: '0 auto'
        }}>
          {servicio.icon}
        </div>
        
        <h3 style={{
          fontSize: '1.1rem',
          fontWeight: 'bold',
          color: '#111827',
          marginBottom: '0.75rem',
          minHeight: '2.5rem',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          justifyContent: 'center'
        }}>
          {servicio.title}
        </h3>
        
        <p style={{
          fontSize: '0.875rem',
          lineHeight: '1.5',
          color: '#6B7280',
          marginBottom: '1rem',
          flex: 1,
          position: 'relative',
          zIndex: 1,
          textAlign: 'center'
        }}>
          {servicio.description}
        </p>
        
        <div style={{
          borderTop: '1px solid #E5E7EB',
          paddingTop: '0.75rem',
          marginTop: 'auto',
          position: 'relative',
          zIndex: 1
        }}> 
                      {servicio.features.map((feature: string, idx: number) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.5rem',
              fontSize: '0.8rem',
              color: '#374151'
            }}>
              <Check size={14} style={{ color: servicio.color }} />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <section id="servicios" style={{
      padding: '3rem 1rem',
      position: 'relative',
      backgroundColor: '#FAFAFA',
      overflow: 'hidden'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #servicios .services-grid {
            grid-template-columns: 1fr !important;
            gap: 1.5rem !important;
          }
          
          #servicios .section-title {
            font-size: 2rem !important;
          }
          
          #servicios .section-subtitle {
            font-size: 1rem !important;
            padding: 0 1rem !important;
          }
        }
      `}</style>
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title" style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: '#111827',
            marginBottom: '1rem',
            position: 'relative',
            display: 'inline-block'
          }}>
            Nuestros Servicios
            <div style={{
              position: 'absolute',
              bottom: '-0.5rem',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '3rem',
              height: '0.25rem',
              backgroundColor: '#FBBF24',
              borderRadius: '0.25rem'
            }}></div>
          </h2>
          
          <p className="section-subtitle" style={{
            fontSize: '1.125rem',
            color: '#6B7280',
            maxWidth: '600px',
            margin: '1.5rem auto 0'
          }}>
            Soluciones integrales en construcción con tecnología de vanguardia y 
            el respaldo de más de 15 años de experiencia en el mercado.
          </p>
        </div>
        
        <div className="services-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1.5rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {servicios.map((servicio, index) => (
            <ServicioCard key={index} servicio={servicio} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const ValoresSection = () => {
  const handleCotizarClick = () => {
    const cotizarBtn = document.querySelector('#cotizar-btn');
    if (cotizarBtn) {
      (cotizarBtn as HTMLButtonElement).click();
    }
  };

  const planes = [
    {
      titulo: 'PANELES SIP',
      subtitulo: 'Sistema Estructural Premium',
      precio: '$$$$$$',
      unidad: 'por m²',
      imagen: imagen14,
      destacado: false,
      caracteristicas: [
        'Panel OSB de 15mm + EPS 100mm',
        'Aislación térmica R-25',
        'Resistencia al fuego F-30',
        'Instalación en 3 días',
        'Ahorro energético 40%',
        'Garantía estructural 10 años'
      ],
      especificaciones: {
        'Espesor': '115mm - 165mm',
        'Densidad EPS': '15 kg/m³',
        'Resistencia': '120 kg/m²',
        'Certificación': 'NCh 3502'
      }
    },
    {
      titulo: 'CERCHAS METALCON',
      subtitulo: 'Estructura de Acero Galvanizado',
      precio: '$$$$$$',
      unidad: 'por unidad',
      imagen: imagen16,
      destacado: false,
      label: '',
      caracteristicas: [
        'Acero galvanizado G90',
        'Diseño computarizado BIM',
        'Cálculo estructural incluido',
        'Montaje en 1 día',
        'Resistencia sísmica',
        'Sin mantención'
      ],
      especificaciones: {
        'Luz máxima': '12 metros',
        'Pendiente': '15% - 40%',
        'Galvanizado': 'G90 Z275',
        'Norma': 'NCh 427'
      }
    },
    {
      titulo: 'KIT OBRA GRUESA',
      subtitulo: 'Solución Integral Llave en Mano',
      precio: '$$$$$$$',
      unidad: 'casa 70m²',
      imagen: imagen32,
      destacado: false,
      caracteristicas: [
        'Paneles SIP completos',
        'Estructura Metalcon',
        'Cubierta y aislación',
        'Planos y permisos',
        'Asesoría técnica',
        'Instalación incluida'
      ],
      especificaciones: {
        'Superficie': '70m² - 140m²',
        'Plazo entrega': '30 días',
        'Incluye': 'Materiales + M.O.',
        'Garantía': '5 años'
      }
    }
  ];

  return (
    <section id="valores" style={{
      padding: '3rem 1rem',
      backgroundColor: '#f8f9fa',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #valores .planes-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          
          #valores .section-title {
            font-size: 2rem !important;
          }
          
          #valores .section-subtitle {
            font-size: 1rem !important;
            padding: 0 1rem !important;
          }
          
          #valores .plan-precio {
            font-size: 2rem !important;
          }
          
          #valores .plan-image {
            height: 250px !important;
          }
        }
      `}</style>

      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(251, 191, 36, 0.05) 0%, transparent 50%)',
        pointerEvents: 'none'
      }} />

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title" style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#111827',
            marginBottom: '1rem'
          }}>
            Nuestros Valores
          </h2>
          <p className="section-subtitle" style={{
            fontSize: '1.25rem',
            color: '#6b7280',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Soluciones constructivas adaptadas a cada proyecto, con la mejor relación calidad-precio del mercado
          </p>
        </div>

        <div className="planes-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          {planes.map((plan, index) => (
            <div
              key={index}
              style={{
                backgroundColor: 'white',
                borderRadius: '1rem',
                overflow: 'hidden',
                boxShadow: plan.destacado 
                  ? '0 25px 50px rgba(251, 191, 36, 0.15)' 
                  : '0 10px 30px rgba(0, 0, 0, 0.08)',
                transform: plan.destacado ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease',
                position: 'relative',
                border: plan.destacado ? '3px solid #FBBF24' : '1px solid #e5e7eb'
              }}
              onMouseEnter={(e) => {
                if (!plan.destacado) {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.12)';
                }
              }}
              onMouseLeave={(e) => {
                if (!plan.destacado) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                }
              }}
            >
              {plan.label && (
                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  backgroundColor: '#FBBF24',
                  color: 'white',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '1rem',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  zIndex: 2
                }}>
                  {plan.label}
                </div>
              )}

              <div className="plan-image" style={{
                height: '200px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img
                  src={plan.imagen}
                  alt={plan.titulo}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '50%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)'
                }} />
              </div>

              <div style={{ padding: '1.5rem' }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: '#111827',
                  marginBottom: '0.5rem'
                }}>
                  {plan.titulo}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#6b7280',
                  marginBottom: '1.5rem'
                }}>
                  {plan.subtitulo}
                </p>

                <div style={{ marginBottom: '1.5rem' }}>
                  <span className="plan-precio" style={{
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                    color: plan.destacado ? '#FBBF24' : '#111827'
                  }}>
                    {plan.precio}
                  </span>
                  <span style={{
                    fontSize: '1rem',
                    color: '#6b7280',
                    marginLeft: '0.5rem'
                  }}>
                    {plan.unidad}
                  </span>
                </div>

                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  marginBottom: '1.5rem'
                }}>
                  {plan.caracteristicas.map((caracteristica, idx) => (
                    <li key={idx} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      marginBottom: '0.75rem',
                      fontSize: '0.9rem',
                      color: '#374151'
                    }}>
                      <Check size={16} style={{ color: '#10b981', flexShrink: 0 }} />
                      <span>{caracteristica}</span>
                    </li>
                  ))}
                </ul>

                <div style={{
                  borderTop: '1px solid #e5e7eb',
                  paddingTop: '1rem',
                  marginBottom: '1rem'
                }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: '#111827',
                    marginBottom: '0.75rem'
                  }}>
                    Especificaciones Técnicas
                  </h4>
                  {Object.entries(plan.especificaciones).map(([key, value]) => (
                    <div key={key} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '0.5rem',
                      fontSize: '0.875rem'
                    }}>
                      <span style={{ color: '#6b7280' }}>{key}:</span>
                      <span style={{ 
                        color: '#111827', 
                        fontWeight: '500',
                        textAlign: 'right'
                      }}>
                        {value}
                      </span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={handleCotizarClick}
                  style={{
                    backgroundColor: '#FBBF24',
                    color: '#1A1A1A',
                    padding: '0.75rem 2rem',
                    borderRadius: '0.5rem',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(251, 191, 36, 0.4)',
                    transform: 'scale(1)',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#F59E0B';
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(251, 191, 36, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#FBBF24';
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(251, 191, 36, 0.4)';
                  }}
                >
                  Solicitar Cotización
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};


const QuienesSomosSection = () => {
  const [galeriaModalOpen, setGaleriaModalOpen] = useState(false);

  const handleCotizarClick = () => {
    const cotizarBtn = document.querySelector('#cotizar-btn');
    if (cotizarBtn) {
      (cotizarBtn as HTMLButtonElement).click();
    }
  };

  const scrollToId = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="quienes-somos" style={{
      position: 'relative',
      padding: '3rem 1rem',
      background: 'linear-gradient(to bottom right, #FAF9F9, #F3F4F6)',
      overflow: 'hidden'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #quienes-somos .section-title {
            font-size: 2rem !important;
          }
          
          #quienes-somos .grid-container {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          
          #quienes-somos .text-column {
            grid-column: span 1 !important;
          }
          
          #quienes-somos .image-column {
            grid-column: span 1 !important;
            order: 0 !important;
          }
          
          #quienes-somos .stats-container {
            flex-direction: column !important;
            gap: 2rem !important;
          }
          
          #quienes-somos .cta-buttons {
            flex-direction: column !important;
            gap: 1rem !important;
          }
          
          #quienes-somos .tech-features {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }

          #quienes-somos .mission-vision-grid {
            grid-template-columns: 1fr !important;
            gap: 1.5rem !important;
          }
        }
      `}</style>

      {/* Fondo decorativo sutil */}
      <div style={{
        position: 'absolute',
        inset: 0,
        opacity: 0.05
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: 'url("https://source.unsplash.com/featured/?construction,building")'
        }} />
      </div>

      <div style={{
        position: 'relative',
        zIndex: 10,
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Título de la sección */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title" style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#111827',
            marginBottom: '1rem'
          }}>
            Quiénes Somos
          </h2>
          <div style={{
            width: '4rem',
            height: '0.25rem',
            backgroundColor: '#FBBF24',
            margin: '0 auto',
            borderRadius: '9999px'
          }} />
        </div>

        {/* Contenido principal */}
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          {/* Primera sección: Visión y Misión ACTUALIZADA */}
          <div style={{ marginBottom: '4rem' }}>
            <div className="grid-container" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              gap: '2rem',
              alignItems: 'flex-start'
            }}>
              <div className="text-column" style={{ gridColumn: 'span 3' }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: '#111827',
                  marginBottom: '2rem',
                  textAlign: 'center'
                }}>
                  Misión y Visión
                </h3>
                
                {/* Grid para Misión y Visión */}
                <div className="mission-vision-grid" style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '2rem',
                  marginBottom: '1.5rem'
                }}>
                  {/* Misión */}
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1.5rem',
                    borderRadius: '0.75rem',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #F3F4F6',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
                  }}>
                    <h4 style={{
                      fontSize: '1.25rem',
                      fontWeight: '700',
                      color: '#D97706',
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span style={{
                        width: '2rem',
                        height: '2rem',
                        backgroundColor: '#FEF3C7',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem'
                      }}>🎯</span>
                      Misión
                    </h4>
                    <p style={{
                      fontSize: '0.95rem',
                      color: '#374151',
                      lineHeight: '1.6'
                    }}>
                      Fabricar paneles SIP de alta calidad que contribuyan a la construcción de edificaciones eficientes, sostenibles y seguras, ofreciendo soluciones innovadoras que reduzcan tiempos de obra y mejoren el desempeño energético de los espacios habitables.
                    </p>
                  </div>

                  {/* Visión */}
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1.5rem',
                    borderRadius: '0.75rem',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #F3F4F6',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
                  }}>
                    <h4 style={{
                      fontSize: '1.25rem',
                      fontWeight: '700',
                      color: '#D97706',
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span style={{
                        width: '2rem',
                        height: '2rem',
                        backgroundColor: '#FEF3C7',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem'
                      }}>🚀</span>
                      Visión
                    </h4>
                    <p style={{
                      fontSize: '0.95rem',
                      color: '#374151',
                      lineHeight: '1.6'
                    }}>
                      Ser la empresa líder en soluciones constructivas con paneles SIP en la región, reconocida por su compromiso con la innovación, la sostenibilidad ambiental y la excelencia en el servicio al cliente.
                    </p>
                  </div>
                </div>

                {/* Texto complementario */}
                <p style={{
                  fontSize: '1.1rem',
                  color: '#374151',
                  lineHeight: '1.75',
                  textAlign: 'center',
                  fontStyle: 'italic',
                  padding: '1rem',
                  backgroundColor: '#FEF3C7',
                  borderRadius: '0.5rem',
                  border: '1px solid #FDE68A'
                }}>
                  Nuestro sistema constructivo en base a{' '}
                  <strong style={{ color: '#D97706' }}>Paneles SIP (Structural Insulated Panels)</strong>{' '}
                  crea la combinación perfecta para un resultado de excelencia.
                </p>
              </div>
              
              <div className="image-column" style={{ gridColumn: 'span 2' }}>
                <div style={{
                  overflow: 'hidden',
                  borderRadius: '0.5rem',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  height: '16rem'
                }}>
                  <img 
                    src={imagen32} 
                    alt="Equipo de trabajo profesional" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.7s',
                      transform: 'scale(1)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Segunda sección: Ventajas del Panel SIP */}
          <div style={{ marginBottom: '4rem' }}>
            <div className="grid-container" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              gap: '2rem',
              alignItems: 'center'
            }}>
              <div className="image-column" style={{ gridColumn: 'span 2', order: 2 }}>
                <div style={{
                  overflow: 'hidden',
                  borderRadius: '0.5rem',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  height: '16rem'
                }}>
                  <img 
                    src={imagen15} 
                    alt="Construcción con Paneles SIP" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.7s',
                      transform: 'scale(1)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </div>
              </div>
              
              <div className="text-column" style={{ gridColumn: 'span 3', order: 1 }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  marginBottom: '1rem'
                }}>
                  <img 
                    src={imgUSAEU} 
                    alt="Bandera USA y UE" 
                    style={{
                      width: '3rem',
                      height: '3rem',
                      borderRadius: '50%',
                      marginRight: '1rem'
                    }}
                  />
                  <h3 style={{
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: '#111827'
                  }}>
                    Con tecnología de vanguardia
                  </h3>
                </div>

                <p style={{
                  fontSize: '1.125rem',
                  color: '#374151',
                  lineHeight: '1.75',
                  marginBottom: '1.5rem'
                }}>
                  El panel SIP estructural, debido a su{' '}
                  <span style={{ color: '#D97706', fontWeight: '600' }}>
                    rapidez y facilidad de instalación
                  </span>, ahorro energético, aislación térmico-acústica y retardo al fuego,
                  se ha posicionado en los últimos diez años como el{' '}
                  <strong>material de construcción número uno en ventas</strong>{' '}
                  tanto en Europa como en Norteamérica.
                </p>

                {/* Características destacadas */}
                <div className="tech-features" style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '1rem'
                }}>
                  {[
                    { icon: <Zap size={20} />, text: 'Instalación Rápida' },
                    { icon: <Shield size={20} />, text: 'Ahorro Energético' },
                    { icon: <Volume2 size={20} />, text: 'Aislación Superior' },
                    { icon: <Flame size={20} />, text: 'Retardo al Fuego' }
                  ].map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        transition: 'background-color 0.3s',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#FEF3C7';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <span style={{ color: '#F59E0B' }}>{item.icon}</span>
                      <span style={{ color: '#374151' }}>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Tercera sección: Experiencia y Equipo */}
          <div style={{ marginBottom: '4rem' }}>
            <div className="grid-container" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              gap: '2rem',
              alignItems: 'center'
            }}>
              <div className="text-column" style={{ gridColumn: 'span 3' }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: '#111827',
                  marginBottom: '1rem'
                }}>
                  Experiencia que Respalda
                </h3>
                <p style={{
                  fontSize: '1.125rem',
                  color: '#374151',
                  lineHeight: '1.75',
                  marginBottom: '1.5rem'
                }}>
                  Todo lo anterior unido a más de{' '}
                  <span style={{ fontWeight: 'bold', color: '#D97706' }}>
                    15 años de experiencia
                  </span>{' '}
                  de un gran equipo de trabajo, compuesto por Ingenieros, Arquitectos
                  y diferentes profesionales en el área de la construcción, nos hace ser{' '}
                  <strong>su opción perfecta</strong> al momento de tomar la decisión
                  de su vida de cómo y con quién construir sus sueños.
                </p>
                
                {/* Estadísticas */}
                <div style={{
                  backgroundColor: '#111827',
                  color: 'white',
                  borderRadius: '0.5rem',
                  padding: '1.5rem',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s',
                  transform: 'scale(1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 20px 25px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }}>
                  <div className="stats-container" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <div style={{ textAlign: 'center' }}>
                      <p style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#FBBF24'
                      }}>+15 Años</p>
                      <p style={{ fontSize: '0.875rem' }}>de experiencia</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#FBBF24'
                      }}>+120</p>
                      <p style={{ fontSize: '0.875rem' }}>proyectos completados</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#FBBF24'
                      }}>100%</p>
                      <p style={{ fontSize: '0.875rem' }}>compromiso</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="image-column" style={{ gridColumn: 'span 2' }}>
                <div style={{
                  overflow: 'hidden',
                  borderRadius: '0.5rem',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  height: '16rem'
                }}>
                  <img 
                    src={imagen36} 
                    alt="Experiencia" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.7s',
                      transform: 'scale(1)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action Final */}
          <div style={{
            textAlign: 'center',
            background: 'linear-gradient(to right, #F59E0B, #D97706)',
            borderRadius: '0.75rem',
            padding: '2rem',
            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '1rem'
            }}>
              Su opción perfecta para construir sus sueños
            </h3>
            <p style={{
              fontSize: '1.125rem',
              color: 'white',
              marginBottom: '2rem',
              opacity: 0.9
            }}>
              La decisión más importante de su vida comienza aquí
            </p>
            <div className="cta-buttons" style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center'
            }}>
              <button 
                onClick={() => setGaleriaModalOpen(true)} // Abrir el modal
                style={{
                  backgroundColor: 'white',
                  color: '#D97706',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#F3F4F6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                }}
              >
                Ver Proyectos
              </button>
              <button
                onClick={handleCotizarClick}
                style={{
                  backgroundColor: '#FBBF24',
                  color: '#1A1A1A',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(251, 191, 36, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#F59E0B';
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(251, 191, 36, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#FBBF24';
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(251, 191, 36, 0.4)';
                }}
              >
                <LucideMail size={18} /> Cotiza con nosotros
              </button>
            </div>
          </div>
        </div>
      </div>
      <GaleriaModal 
        isOpen={galeriaModalOpen} 
        onClose={() => setGaleriaModalOpen(false)} 
      />
    </section>
  );
};

const GaleriaModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [filtroActivo, setFiltroActivo] = useState('Todas');

  // Datos de proyectos
  // const proyectosFeatured = [
  //   { 
  //     id: 1,
  //     image: imagen1,
  //     title: 'Proyecto Residencial',
  //     description: 'Casa unifamiliar con paneles SIP en Viña del Mar. Construcción en tiempo récord de 3 meses.',
  //     category: 'Residencial'
  //   },
  //   { 
  //     id: 2,
  //     image: imagen2,
  //     title: 'Edificio Corporativo',
  //     description: 'Oficinas de 3 pisos construidas con tecnología SIP, entregando eficiencia energética clase A.',
  //     category: 'Comercial'
  //   },
  //   { 
  //     id: 3,
  //     image: imagen3,
  //     title: 'Casa Moderna',
  //     description: 'Diseño contemporáneo con eficiencia energética y aislamiento acústico premium.',
  //     category: 'Residencial'
  //   },
  //   { 
  //     id: 4,
  //     image: imagen4,
  //     title: 'Estructura SIP',
  //     description: 'Instalación de paneles estructurales para proyecto rural en la zona central.',
  //     category: 'Rural'
  //   },
  //   { 
  //     id: 5,
  //     image: imagen5,
  //     title: 'Proyecto Ecológico',
  //     description: 'Construcción sostenible certificada con huella de carbono reducida.',
  //     category: 'Sostenible'
  //   },
  //   { 
  //     id: 6,
  //     image: imagen6,
  //     title: 'Casa Prefabricada',
  //     description: 'Montaje rápido en zona rural utilizando tecnología SIP de última generación.',
  //     category: 'Prefabricado'
  //   }
  // ];
  
  // const proyectosGrid = [
  //   { id: 7, image: imagen7, title: 'Casa del Lago', category: 'Residencial' },
  //   { id: 8, image: imagen8, title: 'Oficinas Centro', category: 'Comercial' },
  //   { id: 9, image: imagen9, title: 'Eco-Cabaña', category: 'Sostenible' },
  //   { id: 10, image: imagen10, title: 'Edificio Mirador', category: 'Comercial' },
  //   { id: 11, image: imagen11, title: 'Mini Casa', category: 'Residencial' },
  //   { id: 12, image: imagen12, title: 'Casa de Montaña', category: 'Rural' },
  //   { id: 13, image: imagen13, title: 'Centro Cultural', category: 'Público' },
  //   { id: 14, image: imagen14, title: 'Vivienda Eficiente', category: 'Residencial' }
  // ];


  const proyectosFeatured = [
    { id: 1, image: imagen1, title: '', description: '', category: '' },
    { id: 2, image: imagen2, title: '', description: '', category: '' },
    { id: 3, image: imagen3, title: '', description: '', category: '' },
    { id: 4, image: imagen4, title: '', description: '', category: '' },
    { id: 5, image: imagen5, title: '', description: '', category: '' },
    { id: 6, image: imagen6, title: '', description: '', category: '' }
  ];
  
  const proyectosGrid = [
    { id: 7, image: imagen7, title: '', description: '', category: '' },
    { id: 8, image: imagen8, title: '', description: '', category: '' },
    { id: 9, image: imagen9, title: '', description: '', category: '' },
    { id: 10, image: imagen10, title: '', description: '', category: '' },
    { id: 11, image: imagen11, title: '', description: '', category: '' },
    { id: 12, image: imagen12, title: '', description: '', category: '' },
    { id: 13, image: imagen13, title: '', description: '', category: '' },
    { id: 14, image: imagen14, title: '', description: '', category: '' }
  ];
  

  const allProyectos = [...proyectosFeatured, ...proyectosGrid];
  const categorias = ['Todas', ...Array.from(new Set(allProyectos.map(item => item.category)))];
  
  const proyectosFiltrados = allProyectos.filter(
    proyecto => filtroActivo === 'Todas' || proyecto.category === filtroActivo
  );

  const openImageModal = (proyecto: any) => {
    setSelectedImage(proyecto);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Fondo del modal */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000,
          animation: 'fadeIn 0.3s ease-in-out'
        }}
        onClick={onClose}
      />

      {/* Contenido del modal */}
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '1rem',
        maxWidth: '90vw',
        maxHeight: '90vh',
        width: '1200px',
        height: '80vh',
        overflow: 'hidden',
        zIndex: 1001,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        animation: 'slideIn 0.3s ease-in-out',
        display: 'flex',
        flexDirection: 'column'
      }}>
    {/* Header del modal */}
<div style={{
  padding: '1.5rem 2rem',
  borderBottom: '1px solid #E5E7EB',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}}>
  <h2 style={{
    fontSize: '1.75rem',
    fontWeight: 'bold',
    color: '#111827'
  }}>
    Galería de Proyectos
  </h2>
  <button
    onClick={onClose}
    style={{
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#6B7280',
      padding: '0.5rem',
      borderRadius: '0.5rem',
      transition: 'all 0.3s'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = '#F3F4F6';
      e.currentTarget.style.color = '#111827';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = 'transparent';
      e.currentTarget.style.color = '#6B7280';
    }}
  >
    ✕
  </button>
</div>

{/* Contenido scrolleable */}
<div style={{
  flex: 1,
  overflow: 'auto',
  padding: '2rem'
}}>
  {/* Filtros de categoría */}
{/* Filtros de categoría */}
<div style={{
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '0.75rem',
  marginBottom: '2rem'
}}>
  {categorias.map((categoria) => {
    // Verificar que la categoría no esté vacía antes de mostrarla
    if (categoria) {
      return (
        <button
          key={categoria}
          onClick={() => setFiltroActivo(categoria)}
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '2rem',
            border: 'none',
            backgroundColor: filtroActivo === categoria ? '#000000' : '#E2E8F0',
            color: filtroActivo === categoria ? 'white' : '#1E293B',
            fontWeight: filtroActivo === categoria ? 'bold' : 'normal',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
        >
          {categoria}
        </button>
      );
    }
    return null;  // No renderizar el filtro si la categoría está vacía
  })}
</div>


  {/* Grid de proyectos */}
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '1.5rem'
  }}>
    {proyectosFiltrados.map((proyecto) => (
      <div
        key={proyecto.id}
        onClick={() => openImageModal(proyecto)}
        style={{
          position: 'relative',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s',
          aspectRatio: '1',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-0.5rem)';
          e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        }}
      >
        <img
          src={proyecto.image}
          alt={proyecto.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: '1rem',
          background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)',
          color: 'white'
        }}>
          {/* Mostrar solo si el title no está vacío */}
          {proyecto.title && (
            <h3 style={{ 
              fontWeight: 'bold', 
              marginBottom: '0.25rem',
              fontSize: '1rem'
            }}>
              {proyecto.title}
            </h3>
          )}
          {/* Mostrar solo si la categoría no está vacía */}
          {proyecto.category && (
            <div style={{
              display: 'inline-block',
              padding: '0.25rem 0.5rem',
              backgroundColor: '#FBBF24',
              color: '#000',
              borderRadius: '1rem',
              fontSize: '0.75rem',
              fontWeight: 'bold'
            }}>
              {proyecto.category}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
</div>

      </div>

   {/* Modal de imagen individual */}
{selectedImage && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1002,
    padding: '1rem',
    animation: 'fadeIn 0.3s ease-in-out' // Animación para abrir el modal
  }} onClick={closeImageModal}>
    <div style={{
      backgroundColor: 'white',
      borderRadius: '1rem',
      overflow: 'hidden',
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      animation: 'scaleIn 0.3s ease-in-out', // Corregida animación de entrada
    }} onClick={(e) => e.stopPropagation()}>
      <div style={{
        height: '400px',
        overflow: 'hidden'
      }}>
        <img
          src={selectedImage.image}
          alt={selectedImage.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </div>

      {/* Cerrar Modal con X */}
      <button
        onClick={closeImageModal}
        style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          background: 'none',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer',
          color: '#FFFFFF',
          padding: '0.5rem',
          borderRadius: '50%',
          transition: 'all 0.3s ease',
          zIndex: 1003
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#F3F4F6';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        ✕
      </button>

      <div style={{
      }}>
        {/* Mostrar solo si el título no está vacío */}
        {selectedImage.title && (
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#000000',
            marginBottom: '1rem'
          }}>
            {selectedImage.title}
          </h3>
        )}

        {/* Descripción */}
        {selectedImage.description && (
          <p style={{
            lineHeight: '1.6',
            color: '#4B5563'
          }}>
            {selectedImage.description}
          </p>
        )}
      </div>
    </div>
  </div>
)}

{/* Estilos de animación */}
<style>{`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`}</style>

    </>
  );
};

const ProyectoObraGruesaSection = () => {
  const handleCotizarClick = () => {
    const cotizarBtn = document.querySelector('#cotizar-btn');
    if (cotizarBtn) {
      (cotizarBtn as HTMLButtonElement).click();
    }
  };
  
  const servicios = [
    {
      titulo: '1. Fabricación de Paneles',
      descripcion: 'Fabricamos paneles SIP de alta calidad, diseñados según las especificaciones de cada proyecto. Empleamos materiales sostenibles y un riguroso control de calidad para garantizar resistencia estructural, eficiencia térmica y precisión dimensional en cada unidad.',
      imagen: imagen29,
      iconos: []
    },
    {
      titulo: '2.MONTAJE',
      descripcion: 'Instalación de obra gruesa completa incluye paneles sip estructurales interiores, cerchas de metalcon tabiquería y techo, cliente debe contar con radier para su correcta instalación en caso de requerir este.',
      imagen: imagen3,
      iconos: []
    },
    {
      titulo: '3. KIT BÁSICO',
      descripcion: 'Pack de Autoconstrucción, incluye planimetría completa de proyecto, Paneles SIP, maderas, uniones, fijaciones y adhesivos.\n\nRápido, térmico, antisísmico, económico e inteligente',
      imagen: imagen1,
      iconos: []
    },
   
  ];

  return (
    <section id="proyecto-obra-gruesa" style={{
      backgroundColor: '#2D2D2D',
      color: 'white',
      padding: '3rem 1rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #proyecto-obra-gruesa .services-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          
          #proyecto-obra-gruesa .section-title {
            font-size: 2rem !important;
            line-height: 1.2 !important;
          }
          
          #proyecto-obra-gruesa .service-image {
            height: 250px !important;
          }
          
          #proyecto-obra-gruesa .stats-grid {
            flex-direction: column !important;
            gap: 2rem !important;
          }
        }
      `}</style>

      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)',
        pointerEvents: 'none'
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title" style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#FBBF24',
            marginBottom: '1rem',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
          }}>
            En solo 30 Días Proyecto Obra Gruesa Terminado
          </h2>
        </div>

        <div className="services-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          {servicios.map((servicio, index) => (
            <div key={index} style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              transform: 'translateY(0)',
              transition: 'transform 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}>
              <div className="service-image" style={{
                position: 'relative',
                width: '100%',
                height: '300px',
                borderRadius: '10px',
                overflow: 'hidden',
                marginBottom: '1.5rem',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                transition: 'box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(251, 191, 36, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.3)';
              }}>
                <img 
                  src={servicio.imagen} 
                  alt={servicio.titulo}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.5s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                />
              </div>

              <div style={{ flex: 1, padding: '0 0.5rem' }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: '#FBBF24',
                  marginBottom: '1rem',
                  textTransform: 'uppercase',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#FCD34D';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#FBBF24';
                }}>
                  {servicio.titulo}
                </h3>
                
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: '#E0E0E0',
                  whiteSpace: 'pre-line'
                }}>
                  {servicio.descripcion}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="stats-grid" style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '6rem',
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
              <div style={{ 
            textAlign: 'center',
            transition: 'transform 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}>
            <div style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              color: '#FBBF24'
            }}>+15</div>
            <p style={{ color: '#E0E0E0', marginTop: '0.5rem' }}>años de experiencia</p>
          </div>
          <div style={{ 
            textAlign: 'center',
            transition: 'transform 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}>
            <div style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              color: '#FBBF24'
            }}>+120</div>
            <p style={{ color: '#E0E0E0', marginTop: '0.5rem' }}>proyectos completados</p>
          </div>
      
          <div style={{ 
            textAlign: 'center',
            transition: 'transform 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}>
            <div style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              color: '#FBBF24'
            }}>100%</div>
            <p style={{ color: '#E0E0E0', marginTop: '0.5rem' }}>compromiso</p>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <button
            onClick={handleCotizarClick}
            style={{
              backgroundColor: '#FBBF24',
              color: '#1A1A1A',
              padding: '1rem 3rem',
              borderRadius: '0.5rem',
              fontWeight: 'bold',
              fontSize: '1.125rem',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(251, 191, 36, 0.4)',
              transform: 'scale(1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#F59E0B';
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(251, 191, 36, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FBBF24';
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(251, 191, 36, 0.4)';
            }}
          >
            Solicitar Cotización
          </button>
        </div>
      </div>
    </section>
  );
};

const SistemaConstruccion = () => {
  const [isSIP, setIsSIP] = useState(true);

  return (
    <section id="que-es-sip" style={{ 
      position: 'relative',
      minHeight: '100vh',
      overflow: 'hidden'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #que-es-sip .image-container {
            flex-direction: column !important;
          }
          
          #que-es-sip .image-half {
            width: 100% !important;
            height: 100vh !important;
          }
          
          #que-es-sip .divider-line {
            width: 100% !important;
            height: 4px !important;
            top: 50% !important;
            left: 0 !important;
            transform: translateY(-50%) !important;
          }
          
          #que-es-sip .content-title {
            font-size: 2rem !important;
            margin-bottom: 2rem !important;
            padding: 0 1rem !important;
          }
          
          #que-es-sip .switch-container {
            margin: 0 1rem !important;
          }
          
          #que-es-sip .switch-buttons {
            flex-direction: row !important;
            gap: 0.5rem !important;
            padding: 0.5rem !important;
          }
          
          #que-es-sip .switch-button {
            padding: 0.5rem 1rem !important;
            font-size: 0.875rem !important;
          }
          
          #que-es-sip .info-container {
            margin: 0 1rem !important;
            padding: 1.5rem !important;
            max-width: 100% !important;
          }
          
          #que-es-sip .info-title {
            font-size: 1.5rem !important;
          }
          
          #que-es-sip .info-text {
            font-size: 1rem !important;
          }
          
          #que-es-sip .features-grid {
            gap: 0.5rem !important;
            justify-content: center !important;
          }
          
          #que-es-sip .feature-pill {
            font-size: 0.75rem !important;
            padding: 0.4rem 0.8rem !important;
          }
          
          #que-es-sip .feature-pill svg {
            width: 14px !important;
            height: 14px !important;
          }
        }
      `}</style>
      
      {/* Contenedor de imágenes */}
      <div className="image-container" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex'
      }}>
        <div className="image-half" style={{
          width: '50%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <img
            src={imagen14}
            alt="Panel SIP"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: isSIP ? 1 : 0.3,
              transition: 'opacity 0.5s ease'
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: isSIP ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.7)',
            transition: 'background-color 0.5s ease'
          }} />
        </div>
        
        <div className="image-half" style={{
          width: '50%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <img
            src={imagen16}
            alt="Metalcon"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: !isSIP ? 1 : 0.3,
              transition: 'opacity 0.5s ease'
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: !isSIP ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.7)',
            transition: 'background-color 0.5s ease'
          }} />
        </div>
        
        <div className="divider-line" style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          width: '4px',
          height: '100%',
          backgroundColor: '#FBBF24',
          transform: 'translateX(-50%)',
          boxShadow: '0 0 20px rgba(251, 191, 36, 0.5)'
        }} />
      </div>
      
      {/* Contenido */}
      <div style={{
        position: 'relative',
        zIndex: 10,
        minHeight: '120vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem 0'
      }}>
        <h2 className="content-title" style={{
          fontSize: '3rem',
          fontWeight: 'bold',
          color: '#FFFFFF',
          marginBottom: '3rem',
          textAlign: 'center',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
          padding: '0 1rem'
        }}>
          Construimos calidad y excelencia
        </h2>
        
        <div className="switch-container" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '2rem',
          padding: '1rem',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          marginBottom: '3rem'
        }}>
          <div className="switch-buttons" style={{
            display: 'flex',
            gap: '2rem',
            alignItems: 'center'
          }}>
            <button
              className="switch-button"
              onClick={() => setIsSIP(true)}
              style={{
                padding: '1rem 2rem',
                borderRadius: '1rem',
                border: 'none',
                backgroundColor: isSIP ? '#FBBF24' : 'transparent',
                color: isSIP ? '#000' : '#666',
                fontWeight: 'bold',
                fontSize: '1.125rem',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
            >
              Panel SIP
            </button>
            <button
              className="switch-button"
              onClick={() => setIsSIP(false)}
              style={{
                padding: '1rem 2rem',
                borderRadius: '1rem',
                border: 'none',
                backgroundColor: !isSIP ? '#FBBF24' : 'transparent',
                color: !isSIP ? '#000' : '#666',
                fontWeight: 'bold',
                fontSize: '1.125rem',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
            >
              Metalcon
            </button>
          </div>
        </div>
        
        <div className="info-container" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '1rem',
          padding: '2rem',
          maxWidth: '600px',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
          backdropFilter: 'blur(10px)',
          margin: '0 1rem'
        }}>
          <h3 className="info-title" style={{ 
            fontSize: '1.75rem', 
            fontWeight: 'bold', 
            color: '#000000', 
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            {isSIP ? 'Panel SIP' : 'Metalcon'}
          </h3>
          <p className="info-text" style={{
            fontSize: '1.125rem',
            lineHeight: '1.8',
            color: '#4B5563',
            textAlign: 'center',
            marginBottom: '2rem'
          }}>
            {isSIP ? (
              <>
                <strong style={{ color: '#000000' }}>Panel SIP</strong> es un moderno panel estructural aislante 
                de placa de OSB con centro de espuma de poliestireno expandido, que ofrece lo último en cuanto a 
                resistencia térmica, resistencia estructural, facilidad y rapidez de instalación.
              </>
            ) : (
              <>
                <strong style={{ color: '#000000' }}>Metalcon</strong> es un moderno sistema constructivo 
                compuesto por perfiles de acero galvanizado a nivel estructural.
              </>
            )}
          </p>
          
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#6B7280',
            textAlign: 'center',
            marginBottom: '2rem',
            fontStyle: 'italic'
          }}>
            Panel SIP y Metalcon se complementan perfectamente en nuestro sistema constructivo único, 
            creando estructuras que combinan lo mejor de ambas tecnologías: máxima eficiencia 
            energética y resistencia estructural superior.
          </p>
          
          <div className="features-grid" style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.75rem',
            justifyContent: 'center'
          }}>
            {[ 
              { icon: <Flame size={16} />, text: 'Aislamiento térmico' },
              { icon: <Volume2 size={16} />, text: 'Confort acústico' },
              { icon: <TimerIcon size={16} />, text: 'Rápida instalación' },
              { icon: <Sprout size={16} />, text: 'Eco-amigable' },
              { icon: <BicepsFlexed size={16} />, text: 'Alta resistencia' }
            ].map((item, index) => (
              <div key={index} className="feature-pill" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                backgroundColor: '#FBBF24',
                padding: '0.5rem 1rem',
                borderRadius: '2rem',
                fontSize: '0.875rem',
                color: '#000',
                fontWeight: '500'
              }}>
                {item.icon}
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};


const BotonCotizar = ({ setContactOpen }: { setContactOpen: () => void }) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      id="cotizar-btn"
      onClick={setContactOpen}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        backgroundColor: hover ? '#F59E0B' : '#FBBF24',
        color: '#F0F0F0',
        padding: '0.5rem 1.25rem',
        borderRadius: '2rem',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        boxShadow: hover ? '0 6px 20px rgba(251, 191, 36, 0.6)' : '0 4px 6px rgba(251, 191, 36, 0.3)',
        transition: 'all 0.3s ease',
        transform: hover ? 'scale(1.05)' : 'scale(1)'
      }}
    >
      <LucideMail size={18} /> Cotiza con nosotros
    </button>
  );
};

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  telefono: string;
}

const modalAnimationStyle = `
  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.8) translateY(30px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
  
  @keyframes modalFadeOut {
    from {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
    to {
      opacity: 0;
      transform: scale(0.8) translateY(30px);
    }
  }
  
  @keyframes backdropFadeIn {
    from {
      opacity: 0;
      backdrop-filter: blur(0px);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(5px);
    }
  }
  
  @keyframes backdropFadeOut {
    from {
      opacity: 1;
      backdrop-filter: blur(5px);
    }
    to {
      opacity: 0;
      backdrop-filter: blur(0px);
    }
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
    }
  }
`;

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLDivElement>) => void;
  required?: boolean;
  children: React.ReactNode;
}


const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  required = false,
  children
}) => {
    return (
    <label style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem',
      cursor: 'pointer',
      fontSize: '0.875rem',
      color: '#374151',
      lineHeight: '1.5'
    }}>
      <div
        onClick={onChange}
        style={{
          width: '1.25rem',
          height: '1.25rem',
          border: `2px solid ${checked ? '#FBBF24' : '#D1D5DB'}`,
          borderRadius: '0.25rem',
          backgroundColor: checked ? '#FBBF24' : 'white',
          cursor: 'pointer',
          flexShrink: 0,
          marginTop: '0.125rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease',
          position: 'relative'
        }}
      >
        {checked && (
          <Check size={14} color="white" strokeWidth={3} />
        )}
      </div>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        required={required}
        style={{ display: 'none' }}
      />
      <span>{children}</span>
    </label>
  );
};

interface Props {
  nombre: string;
  setNombre: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  telefono: string;
  setTelefono: (value: string) => void;
  mensaje: string;
  setMensaje: (value: string) => void;
  serviciosSeleccionados: string[];
  toggleServicio: (servicio: string) => void;
  acceptedPrivacy: boolean;
  setAcceptedPrivacy: (value: boolean) => void;
  formState: 'idle' | 'loading' | 'success' | 'error';
  errorMessage: string;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
  children?: React.ReactNode;
}

export const ReusableContactForm: React.FC<Props> = ({
  nombre, setNombre,
  email, setEmail,
  telefono, setTelefono,
  mensaje, setMensaje,
  serviciosSeleccionados, toggleServicio,
  acceptedPrivacy, setAcceptedPrivacy,
  formState, errorMessage, onSubmit, onReset,
  children
}) => {

  const formIsValid =
  nombre.trim() !== '' &&
  email.trim() !== '' &&
  mensaje.trim() !== '' &&
  acceptedPrivacy;


  const whatsappMessage = encodeURIComponent(
    `¡Hola! Quiero más información sobre sus servicios.
  
  Nombre: ${nombre}
  Correo: ${email}
  Teléfono: ${telefono}
  Servicios: ${serviciosSeleccionados.join(', ') || 'No especificado'}
  Mensaje: ${mensaje}`
  );
  
  return (
    <>
      {formState === 'success' && (
        <div className="enp-feedback success">
          ¡Mensaje enviado exitosamente!
          <button onClick={onReset} style={{ marginLeft: '1rem' }}>Enviar otro</button>
        </div>
      )}

      {formState === 'error' && (
        <div className="enp-feedback error">{errorMessage}</div>
      )}

      {formState !== 'success' && (
        <form onSubmit={onSubmit} className="enp-form">
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Nombre completo *"
            required
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo electrónico *"
            required
          />
          <input
            type="tel"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            placeholder="Teléfono"
          />
          <textarea
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
            placeholder="Mensaje *"
            required
            rows={4}
          />

          <div>
            <label style={{ marginBottom: '0.25rem', display: 'block' }}>Servicios de interés:</label>
            <div className="enp-service-buttons">
              {['Paneles SIP', 'Cerchas Metalcon', 'Kit Obra Gruesa'].map((servicio) => (
                <button
                  key={servicio}
                  type="button"
                  onClick={() => toggleServicio(servicio)}
                  className={`enp-service-button${serviciosSeleccionados.includes(servicio) ? ' selected' : ''}`}
                >
                  {servicio}
                </button>
              ))}
            </div>
          </div>

          <label className="enp-checkbox-label">
            <input
              type="checkbox"
              checked={acceptedPrivacy}
              onChange={() => setAcceptedPrivacy(!acceptedPrivacy)}
              required
            />
            Acepto la política de privacidad
          </label>

          <button
            type="submit"
            className="enp-submit-btn"
  disabled={formState === 'loading' || !formIsValid}
          >
            {formState === 'loading' ? 'Enviando...' : 'Enviar mensaje'}
          </button>
          <a
  href={formState === 'loading' || !formIsValid ? undefined : `https://wa.me/56912345678?text=${whatsappMessage}`}

  target="_blank"
  rel="noopener noreferrer"
  className="enp-submit-btn"
  onClick={(e) => {
    if (formState === 'loading' || !formIsValid) {
      e.preventDefault(); // Evita navegación si inválido
    }
  }}
  style={{
    backgroundColor: formState === 'loading' || !formIsValid ? '#9ca3af' : '#25D366',
    pointerEvents: formState === 'loading' || !formIsValid ? 'none' : 'auto',
    opacity: formState === 'loading' || !formIsValid ? 0.6 : 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    textDecoration: 'none',
    borderRadius: '0.5rem',
    padding: '1rem',
    fontWeight: 'bold',
    color: 'white'
  }}
>
  <WhatsAppIcon size={20} color="white" />
  Enviar por WhatsApp
</a>


          {children}
        </form>
        
      )}
    </>
  );
};



interface FormStatusProps {
  state: 'idle' | 'loading' | 'success' | 'error';
  errorMessage: string;
  onReset: () => void;
}

const FloatingWhatsApp = () => {
  return (
    <>
      <style>{`
        .floating-whatsapp {
          position: fixed;
          left: 2rem;
          bottom: 2rem;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #25D366 0%, #20BA5E 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
          z-index: 1000;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }

        .floating-whatsapp:hover {
          transform: translateY(-5px) scale(1.1);
          box-shadow: 0 15px 35px rgba(37, 211, 102, 0.6);
          background: linear-gradient(135deg, #20BA5E 0%, #1DA851 100%);
        }

        /* Pulso */
        .floating-whatsapp::before {
          content: '';
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          border-radius: 50%;
          background: rgba(37, 211, 102, 0.3);
          animation: whatsapp-pulse 2s infinite;
          z-index: -1;
        }

        @keyframes whatsapp-pulse {
          0% { transform: scale(0.8); opacity: 1; }
          100% { transform: scale(1.4); opacity: 0; }
        }

        /* Tooltip estilo globito */
        .floating-whatsapp::after {
          content: '¿Tienes dudas?';
          position: absolute;
          bottom: 70px; /* más arriba */
          left: 40%; /* más cargado a la derecha */
          transform: translateX(-20%);
          background: #FFFFFF;
          color: #000;
          padding: 0.6rem 1.2rem;
          border-radius: 1.2rem;
          font-size: 0.9rem;
          white-space: nowrap;
          opacity: 1;
          pointer-events: none;
          font-family: inherit;
          box-shadow: 0 4px 10px rgba(0,0,0,0.25);
        }

    

        @media (max-width: 768px) {
          .floating-whatsapp {
            bottom: 5rem;
            right: 1.5rem;
            width: 55px;
            height: 55px;
          }

          .floating-whatsapp::after,
          .floating-whatsapp::before {
            display: none; /* ocultar globito en móvil */
          }
        }

        @media (max-width: 480px) {
          .floating-whatsapp {
            bottom: 4rem;
            right: 1rem;
            width: 50px;
            height: 50px;
          }
        }
      `}</style>

      <a
        href="https://wa.me/56975885333"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatea por WhatsApp"
        className="floating-whatsapp"
      >
        <WhatsAppIcon size={24} color="white" />
      </a>
    </>
  );
};





const FormStatus: React.FC<FormStatusProps> = ({ state, errorMessage, onReset }) => {
 
  if (state === 'loading') {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        backgroundColor: '#F3F4F6',
        borderRadius: '0.75rem',
        marginBottom: '1rem'
      }}>
        <div style={{
          width: '2rem',
          height: '2rem',
          border: '3px solid #E5E7EB',
          borderTop: '3px solid #FBBF24',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginRight: '1rem'
        }} />
        <span style={{ color: '#6B7280', fontSize: '1rem' }}>
          Enviando mensaje...
        </span>
      </div>
    );
  }

  if (state === 'success') {
    return (
      <div style={{
        backgroundColor: '#D1FAE5',
        border: '1px solid #10B981',
        borderRadius: '0.75rem',
        padding: '1.5rem',
        marginBottom: '1rem',
        textAlign: 'center'
      }}>
        <div style={{
          width: '3rem',
          height: '3rem',
          backgroundColor: '#10B981',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1rem'
        }}>
          <Check size={24} color="white" />
        </div>
        <h3 style={{
          color: '#065F46',
          fontSize: '1.125rem',
          fontWeight: 'bold',
          marginBottom: '0.5rem'
        }}>
          ¡Mensaje enviado correctamente!
        </h3>
        <p style={{
          color: '#047857',
          marginBottom: '1rem',
          fontSize: '0.875rem'
        }}>
          Nos pondremos en contacto contigo a la brevedad.
        </p>
        <button
          onClick={onReset}
          style={{
            backgroundColor: '#10B981',
            color: 'white',
            padding: '0.5rem 1.5rem',
            borderRadius: '0.5rem',
            border: 'none',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
        >
          Enviar otro mensaje
        </button>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div style={{
        backgroundColor: '#FEE2E2',
        border: '1px solid #EF4444',
        borderRadius: '0.75rem',
        padding: '1.5rem',
        marginBottom: '1rem',
        textAlign: 'center'
      }}>
        <div style={{
          width: '3rem',
          height: '3rem',
          backgroundColor: '#EF4444',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1rem'
        }}>
          ✕
        </div>
        <h3 style={{
          color: '#991B1B',
          fontSize: '1.125rem',
          fontWeight: 'bold',
          marginBottom: '0.5rem'
        }}>
          Error al enviar mensaje
        </h3>
        <p style={{
          color: '#B91C1C',
          marginBottom: '1rem',
          fontSize: '0.875rem'
        }}>
          {errorMessage || 'Ocurrió un error inesperado. Por favor, intenta nuevamente.'}
        </p>
        <button
          onClick={onReset}
          style={{
            backgroundColor: '#EF4444',
            color: 'white',
            padding: '0.5rem 1.5rem',
            borderRadius: '0.5rem',
            border: 'none',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
        >
          Intentar nuevamente
        </button>
      </div>
    );
  }

  return null;
};


// Componente de Modal actualizado con animación de salida
const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose }) => {
  // Estado para controlar la animación de salida
  const [isClosing, setIsClosing] = useState(false);
  const [showModal, setShowModal] = useState(isOpen);
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState<string[]>([]);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);

  // En ContactoSection y ContactModal, reemplaza los estados existentes con:
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  
  // Efecto para manejar la apertura y cierre con animaciones
  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
      setIsClosing(false);
    } else if (showModal) {
      // Si el modal está visible pero se solicita cerrarlo
      setIsClosing(true);
      // Esperar a que termine la animación de salida antes de ocultar
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 300); // Duración de la animación de salida
      return () => clearTimeout(timer);
    }
  }, [isOpen, showModal]);

  // Handler para el cierre manual
  const handleClose = () => {
    setIsClosing(true);
    // Esperar a que termine la animación antes de llamar a onClose
    setTimeout(() => {
      onClose();
    }, 300);
  };
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormState('loading');
    setErrorMessage('');
  
    const data = {
      nombre,
      email,
      telefono,
      mensaje,
      servicios: serviciosSeleccionados
    };
  
    try {
      const res = await fetch('https://enprotec.cl/api/contact-handler.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
  
      if (res.ok) {
        setFormState('success');
        // No limpiar los campos aquí, se hará en resetForm
      } else {
        const errorData = await res.text();
        setFormState('error');
        setErrorMessage('Error del servidor. Código: ' + res.status);
      }
    } catch (error) {
      console.error('Error al enviar:', error);
      setFormState('error');
      setErrorMessage('Error de conexión. Verifica tu internet e intenta nuevamente.');
    }
  };
  
  const resetForm = () => {
    setFormState('idle');
    setNombre('');
    setEmail('');
    setTelefono('');
    setMensaje('');
    setServiciosSeleccionados([]);
    setErrorMessage('');
  };
  
  // No renderizar nada si el modal no debería mostrarse
  if (!showModal) return null;

  return (
    <>
      {/* Inyectar los estilos de animación */}
      <style dangerouslySetInnerHTML={{ __html: modalAnimationStyle }} />
      
      <div 
        style={{
          display: 'flex',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          backdropFilter: 'blur(5px)',
          animation: isClosing 
            ? 'backdropFadeOut 0.3s forwards' 
            : 'backdropFadeIn 0.3s forwards',
          overflow: 'hidden'
        }}
        onClick={handleClose}
      >
        <div 
          style={{
            backgroundColor: 'white',
            borderRadius: '1rem',
            maxHeight: '95vh',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            animation: isClosing 
              ? 'modalFadeOut 0.3s forwards' 
              : 'modalFadeIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            display: 'flex',
            flexDirection: 'column'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header compacto */}
          <div style={{
            background: 'linear-gradient(135deg, #000000 0%, #1F2937 100%)',
            padding: '1rem 1.5rem',
            color: 'white',
            position: 'relative',
            borderTopLeftRadius: '1rem',
            borderTopRightRadius: '1rem',
            overflow: 'hidden',
            flexShrink: 0
          }}>
            {/* Título con ícono */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
                <Mail size={20} style={{ color: '#FBBF24' }} />
              </div>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                margin: 0,
                lineHeight: 1.2
              }}>
                Contáctanos
              </h2>
            </div>

            <p style={{
              fontSize: '0.75rem',
              opacity: 0.8,
              margin: '0.25rem 0 0 0'
            }}>
              Completa el formulario y nos pondremos en contacto contigo a la brevedad.
            </p>

            {/* Botón de cierre */}
            <button
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '1rem',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
            >
              ✕
            </button>

            {/* Banda decorativa inferior */}
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '12px',
              background: 'radial-gradient(circle at center, #FBBF24 0%, transparent 70%)',
              opacity: 0.4
            }} />
          </div>

          {/* Contenido del formulario */}
          <div style={{
            padding: '1.5rem',
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <ReusableContactForm
              nombre={nombre}
              setNombre={setNombre}
              email={email}
              setEmail={setEmail}
              telefono={telefono}
              setTelefono={setTelefono}
              mensaje={mensaje}
              setMensaje={setMensaje}
              serviciosSeleccionados={serviciosSeleccionados}
              toggleServicio={(s) => setServiciosSeleccionados(prev =>
                prev.includes(s) ? prev.filter(p => p !== s) : [...prev, s])}
              acceptedPrivacy={acceptedPrivacy}
              setAcceptedPrivacy={setAcceptedPrivacy}
              formState={formState}
              errorMessage={errorMessage}
              onSubmit={handleSubmit}
              onReset={resetForm}
            />
          </div>
        </div>
      </div>
    </>
  );
};
const ContactoSection = () => {
 
  <style>{`
    #contacto input[type="checkbox"] {
      appearance: none;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid #d1d5db;
      border-radius: 0.25rem;
      background-color: white;
      cursor: pointer;
      flex-shrink: 0;
      position: relative;
      margin-top: 0.125rem;
    }
    
    #contacto input[type="checkbox"]:checked {
      background-color: #FBBF24;
      border-color: #FBBF24;
    }
    
    #contacto input[type="checkbox"]:checked::after {
      content: '✓';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 0.875rem;
      font-weight: bold;
    }
      
        #contacto .privacy-checkbox {
      width: 1.25rem !important;
    }
      
    #contacto input[type="checkbox"]:focus {
      outline: 2px solid #FBBF24;
      outline-offset: 2px;
    }
    
    @media (max-width: 768px) {
      /* Otros estilos móviles... */
      
      #contacto .checkbox-label {
        font-size: 0.8rem !important;
      }
    }
  `}</style>
  
  const toggleServicio = (servicio: string) => {
    setServiciosSeleccionados(prev => 
      prev.includes(servicio) 
        ? prev.filter(s => s !== servicio)
        : [...prev, servicio]
    );
  };

  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);

  const [nombre, setNombre] = useState('');
const [email, setEmail] = useState('');
const [telefono, setTelefono] = useState('');
const [mensaje, setMensaje] = useState('');
const [enviado, setEnviado] = useState(false);
const [serviciosSeleccionados, setServiciosSeleccionados] = useState<string[]>([]);
// En ContactoSection y ContactModal, reemplaza los estados existentes con:
const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
const [errorMessage, setErrorMessage] = useState('');
const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  setFormState('loading');
  setErrorMessage('');

  const data = {
    nombre,
    email,
    telefono,
    mensaje,
    servicios: serviciosSeleccionados
  };

  try {
    const res = await fetch('https://enprotec.cl/api/contact-handler.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (res.ok) {
      setFormState('success');
      // No limpiar los campos aquí, se hará en resetForm
    } else {
      const errorData = await res.text();
      setFormState('error');
      setErrorMessage('Error del servidor. Código: ' + res.status);
    }
  } catch (error) {
    console.error('Error al enviar:', error);
    setFormState('error');
    setErrorMessage('Error de conexión. Verifica tu internet e intenta nuevamente.');
  }
};

const resetForm = () => {
  setFormState('idle');
  setNombre('');
  setEmail('');
  setTelefono('');
  setMensaje('');
  setServiciosSeleccionados([]);
  setErrorMessage('');
};

  return (
    <section id="contacto" style={{
      padding: '3rem 1rem',
      backgroundColor: '#ffffff',
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      <style>{`
        @media (max-width: 768px) {
          #contacto {
            padding: 2rem 1rem !important;
          }
          
          #contacto * {
            box-sizing: border-box !important;
          }
          
          #contacto .main-container {
            padding: 0 !important;
            width: 100% !important;
          }
          
          #contacto .grid-container {
            display: block !important;
            width: 100% !important;
          }
          
          #contacto .grid-container > div {
            width: 100% !important;
            margin-bottom: 2rem !important;
          }
          
          #contacto .section-title {
            font-size: 2rem !important;
          }
          
          #contacto .section-subtitle {
            font-size: 1rem !important;
            padding: 0 1rem !important;
          }
          
          #contacto .info-title {
            font-size: 1.5rem !important;
          }
          
          #contacto .form-grid {
            grid-template-columns: 1fr !important;
          }
          
          #contacto .service-buttons {
            flex-direction: column !important;
            width: 100% !important;
          }
          
          #contacto .service-button {
            width: 100% !important;
            justify-content: flex-start !important;
          }
          
          #contacto .map-container {
            height: 300px !important;
            width: 100% !important;
          }
          
          #contacto .contact-cards {
            gap: 0.75rem !important;
          }
          
          #contacto .hours-card {
            padding: 1.5rem !important;
          }
          
          #contacto .whatsapp-button {
            width: 100% !important;
          }
          
          #contacto .form-container {
            padding: 1.5rem !important;
            width: 100% !important;
            margin: 0 !important;
          }
          
          #contacto .contact-card {
            padding: 1rem !important;
          }
          
          #contacto input,
          #contacto textarea,
          #contacto select {
            width: 100% !important;
            box-sizing: border-box !important;
          }
        }
      `}</style>

      {/* Patrón de fondo decorativo */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `
          radial-gradient(circle at 10% 20%, rgba(251, 191, 36, 0.03) 0%, transparent 40%),
          radial-gradient(circle at 80% 80%, rgba(16, 185, 129, 0.03) 0%, transparent 40%)
        `,
        pointerEvents: 'none'
      }} />

      <div className="main-container" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
        width: '100%',
        boxSizing: 'border-box'
      }}>
        {/* Título de la sección */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title" style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#111827',
            marginBottom: '1rem'
          }}>
            Contáctanos
          </h2>
          <p className="section-subtitle" style={{
            fontSize: '1.25rem',
            color: '#6b7280',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Estamos aquí para ayudarte a hacer realidad tu proyecto de construcción
          </p>
        </div>

        <div className="grid-container" style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth > 768 ? 'repeat(2, 1fr)' : '1fr',
          gap: '3rem',
          alignItems: 'start',
          width: '100%'
        }}>
          {/* Información de contacto */}
          <div style={{ width: '100%' }}>
            <h3 className="info-title" style={{
              fontSize: '1.75rem',
              fontWeight: 'bold',
              color: '#111827',
              marginBottom: '2rem'
            }}>
              Información de Contacto
            </h3>

            {/* Tarjetas de contacto */}
            <div className="contact-cards" style={{ marginBottom: '2rem' }}>
              <div className="contact-card" style={{
                backgroundColor: '#f9fafb',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                transition: 'all 0.3s ease',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
                e.currentTarget.style.transform = 'translateX(5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f9fafb';
                e.currentTarget.style.transform = 'translateX(0)';
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#FEF3C7',
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Phone size={24} color="#FBBF24" />
                </div>
                <div style={{ overflow: 'hidden' }}>
                  <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                    Teléfono
                  </p>
                  <a href="tel:+56975885333" style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#111827',
                    textDecoration: 'none',
                    wordBreak: 'break-word'
                  }}>
                    +56 9 7588 5333
                  </a>
                </div>
              </div>

              <div className="contact-card" style={{
                backgroundColor: '#f9fafb',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                transition: 'all 0.3s ease',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
                e.currentTarget.style.transform = 'translateX(5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f9fafb';
                e.currentTarget.style.transform = 'translateX(0)';
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#D1FAE5',
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Mail size={24} color="#10B981" />
                </div>
                <div style={{ overflow: 'hidden' }}>
                  <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                    Email
                  </p>
                  <a href="mailto:contacto@enprotec.cl" style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#111827',
                    textDecoration: 'none',
                    wordBreak: 'break-word'
                  }}>
                    contacto@enprotec.cl
                  </a>
                </div>
              </div>

              <div className="contact-card" style={{
                backgroundColor: '#f9fafb',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                transition: 'all 0.3s ease',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
                e.currentTarget.style.transform = 'translateX(5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f9fafb';
                e.currentTarget.style.transform = 'translateX(0)';
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#DBEAFE',
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <MapPin size={24} color="#3B82F6" />
                </div>
                <div style={{ overflow: 'hidden' }}>
  <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
    Dirección
  </p>
  <p style={{
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#111827',
    wordBreak: 'break-word'
  }}>
    <a
      href="https://www.google.com/maps/place/Sta.+Rosa+de+Santiago+1098,+9380000+Lampa,+Regi%C3%B3n+Metropolitana/@-33.2420783,-70.769201,17z"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      {direccion}
    </a>
  </p>
</div>

              </div>
            </div>

            {/* Horario de atención */}
            {/* <div className="hours-card" style={{
              backgroundColor: '#111827',
              color: 'white',
              borderRadius: '0.75rem',
              padding: '2rem',
              marginBottom: '2rem',
              width: '100%',
              boxSizing: 'border-box'
            }}>
              <h4 style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                flexWrap: 'wrap'
              }}>
                <Clock size={24} color="#FBBF24" />
                Horario de Atención
              </h4>
              <div style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                <p>Lunes a Viernes: 9:00 - 18:00</p>
                <p>Sábados: 9:00 - 13:00</p>
                <p>Domingos: Cerrado</p>
              </div>
            </div> */}
 {/* Mapa */}
 <GoogleMapWithLazyLoad direccion={direccion} />

            {/* Botón de WhatsApp */}
            <a
              href="https://wa.me/56912345678"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-button"
              style={{
                backgroundColor: '#25D366',
                color: 'white',
                padding: '1rem',
                marginTop: '2rem',
                borderRadius: '0.75rem',
                fontWeight: 'bold',
                fontSize: '1.125rem',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.75rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#20BA5E';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#25D366';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <MessageSquare size={24} />
              Chatea con Nosotros
            </a>
          </div>

          {/* Formulario de contacto */}
          <div className="form-container" style={{
            backgroundColor: '#f9fafb',
            borderRadius: '1rem',
            padding: '2.5rem',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            position: 'relative',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            {/* Logo en el formulario */}
            <div style={{
              position: 'absolute',
              top: '2rem',
              right: '2rem',
              opacity: 0.1
            }}>
              <img 
                src={logo} 
                alt="ENPROTEC" 
                style={{
                  width: '80px',
                  filter: 'grayscale(100%)'
                }}
              />
            </div>

            <h3 style={{
              fontSize: '1.75rem',
              fontWeight: 'bold',
              color: '#111827',
              marginBottom: '2rem'
            }}>
              Envíanos un Mensaje
            </h3>

            <FormStatus 
  state={formState} 
  errorMessage={errorMessage} 
  onReset={resetForm} 
/>

{formState !== 'success' && (
 <ReusableContactForm
 nombre={nombre}
 setNombre={setNombre}
 email={email}
 setEmail={setEmail}
 telefono={telefono}
 setTelefono={setTelefono}
 mensaje={mensaje}
 setMensaje={setMensaje}
 serviciosSeleccionados={serviciosSeleccionados}
 toggleServicio={(s) => setServiciosSeleccionados(prev =>
   prev.includes(s) ? prev.filter(p => p !== s) : [...prev, s])}
 acceptedPrivacy={acceptedPrivacy}
 setAcceptedPrivacy={setAcceptedPrivacy}
 formState={formState}
 errorMessage={errorMessage}
 onSubmit={handleSubmit}
 onReset={resetForm}
/>

)}
          </div>

       
      </div>

      </div>
    </section>
  );
};
// Componente mejorado para el mapa de Google
interface GoogleMapProps {
  direccion: string;
}

const GoogleMapWithLazyLoad: React.FC<{ direccion: string }> = ({ direccion }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const mapRef = useRef(null);

  // Detectar cuando el mapa está en el viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
    );

    if (mapRef.current) {
      observer.observe(mapRef.current);
    }

    return () => {
      if (mapRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  // Estilos para el contenedor y el placeholder
  const mapContainerStyle: React.CSSProperties = {
    marginTop: '1rem',
    borderRadius: '0.75rem',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    position: 'relative',
    width: '100%',
    height: '180px',
    backgroundColor: '#f0f0f0',
  };

  const placeholderStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    opacity: isLoaded ? 0 : 1,
    transition: 'opacity 0.5s ease',
    zIndex: isLoaded ? -1 : 1,
  };

  const iframeStyle: React.CSSProperties = {
    border: 0,
    width: '100%',
    height: '100%',
  };

  return (
    <div ref={mapRef} style={mapContainerStyle}>
      <div style={placeholderStyle}>
        <div style={{ marginBottom: '0.5rem' }}>
          <Compass size={24} color="#FBBF24" />
        </div>
        <div style={{ fontSize: '0.875rem', color: '#4B5563' }}>
          Cargando mapa...
        </div>
      </div>

      {isInView && (
        <iframe
          src={`https://www.google.com/maps?q=${encodeURIComponent(direccion)}&output=embed`}
          style={iframeStyle}
          allowFullScreen
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
          title="Ubicación en Google Maps"
        />
      )}
    </div>
  );
};
const direccion = 'Sta.Rosa de Santiago #1098, Batuco, Lampa, RM ';


const LandingPage: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const carouselRef = useRef<HTMLDivElement>(null);
  const telefono = '+56 9 7588 5333';
  const correo = 'ventas@enprotec.cl';
  const [showScrollTop, setShowScrollTop] = useState(true);
  const lastScrollY = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 640;
  const isTablet = typeof window !== 'undefined' && window.innerWidth <= 768;
  
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState<string[]>([]);

  // Configuración del carrusel hero
  const [isContactOpen, setContactOpen] = useState(false);
 
  
  const HeroCarousel = () => {
    const [activeZoom, setActiveZoom] = useState(1);
    const [animating, setAnimating] = useState(false);
    const [heroIndex, setHeroIndex] = useState(0);
    const heroImages = [imagen35]; 
    const totalHeroSlides = heroImages.length;
  
    useEffect(() => {
      const zoomDuration = 60000;
      const targetZoom = 1.2;
      const initialZoom = 1;
      const startTime = Date.now();
    
      const zoomInterval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        const progress = (elapsedTime / zoomDuration) % 1;
        const zoomRange = targetZoom - initialZoom;
    
        let newZoom;
        if (progress < 0.5) {
          newZoom = initialZoom + zoomRange * (progress * 2);
        } else {
          newZoom = targetZoom - zoomRange * ((progress - 0.5) * 2);
        }
    
        setActiveZoom(newZoom);
      }, 50);
    
      return () => clearInterval(zoomInterval);
    }, []);
  
    return (
      <section id="hero" style={{
        position: 'relative',
        width: '100%',
        height: '91vh',
        overflow: 'hidden'
      }}>
        <style>{`
          @media (max-width: 768px) {
            #hero {
              height: 100vh !important;
            }
            
            #hero .hero-text {
              font-size: 2rem !important;
              padding: 0.5rem !important;
            }
            
            #hero .hero-text-container {
              flex-direction: column !important;
              align-items: center !important;
              bottom: 20% !important;
            }
            
            #hero .hero-text-desktop {
              display: none !important;
            }
            
            #hero .hero-text-mobile {
              display: block !important;
              width: 100% !important;
            }
          }
          
          @media (min-width: 769px) {
            #hero .hero-text-mobile {
              display: none !important;
            }
          }
        `}</style>
  
        {/* Imagen del carrusel con zoom continuo */}
        <div style={{
          position: 'absolute',
          inset: 0,
          overflow: 'hidden',
        }}>
          <img
            src={heroImages[heroIndex]}
            alt={`Hero Image ${heroIndex + 1}`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute',
              inset: 0,
              transition: 'opacity 0.8s ease-in-out',
              opacity: animating ? 0 : 1,
              transform: `scale(${activeZoom})`,
              transformOrigin: 'center center',
              zIndex: 1,
              willChange: 'opacity, transform'
            }}
          />
        </div>
  
        {/* Contenido de overlay */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.3))',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
          padding: '2rem',
        }}>
          <div className="hero-text-container" style={{
            position: 'absolute',
            bottom: '0%',
            left: '0',
            right: '0',
            display: 'flex',
            width: '100%'
          }}>
            {/* Texto para desktop */}
            <div className="hero-text hero-text-desktop" style={{
              width: '50%',
              textAlign: 'center',
              color: 'white',
              fontSize: '3rem',
              fontWeight: '800',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
              padding: '1rem'
            }}>
              CONSTRUIMOS
            </div>
  
            <div className="hero-text hero-text-desktop" style={{
              width: '50%',
              textAlign: 'center',
              color: 'white',
              fontSize: '3rem',
              fontWeight: '800',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
              padding: '1rem'
            }}>
              FUTURO
            </div>
  
            {/* Texto para móvil con salto de línea */}
            <div className="hero-text hero-text-mobile" style={{
              textAlign: 'center',
              color: 'white',
              fontSize: '2rem',
              fontWeight: '800',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
              padding: '1rem',
              lineHeight: '1.2'
            }}>
              CONSTRUIMOS<br />FUTURO
            </div>
          </div>
        </div>
      </section>
    );
  };

  interface ContactoLinksProps {
    correo: string;
    telefono: string;
    whatsapp: string;
  }
  
  const ContactoLinks: React.FC<ContactoLinksProps> = ({ correo, telefono, whatsapp }) => {
    return (
      <div className="flex flex-col items-start gap-3 text-white text-sm">
        <a 
          href={`mailto:${correo}`} 
          className="underline decoration-transparent hover:decoration-[#FBBF24] flex items-center gap-2"
        >
          <Mail size={18} />
          {correo}
        </a>
  
        <a 
          href={`tel:${telefono}`} 
          className="underline decoration-transparent hover:decoration-[#FBBF24] flex items-center gap-2"
        >
          <Phone size={18} />
          {telefono}
        </a>
  
        <a 
          href={`https://wa.me/${whatsapp}`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="underline decoration-transparent hover:decoration-[#FBBF24] flex items-center gap-2"
        >
          <MessageSquare size={18} />
          WhatsApp
        </a>
      </div>
    );
  };

  const ScrollToTopButton: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const lastScrollY = useRef(0);
    const buttonRef = useRef<HTMLButtonElement | null>(null);
  
    // Función simplificada para manejar el scroll con respuesta más rápida
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Mostrar/ocultar basado en posición y dirección - respuesta inmediata
      if (currentScrollY < 200 || currentScrollY > lastScrollY.current) {
        setVisible(false); // Ocultar rápido al bajar o cuando estamos arriba
      } else {
        setVisible(true); // Mostrar al subir
      }
      
      lastScrollY.current = currentScrollY;
    };
  
    // Efecto para agregar el evento de scroll
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    // Animación CSS para el botón - ahora con transiciones más rápidas y color amarillo
    const buttonStyle: React.CSSProperties = {
      position: 'fixed',
      bottom: '2rem',
      right: '2rem',
      backgroundColor: '#FBBF24', // Color amarillo de tu plantilla
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '3rem',
      height: '3rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 12px rgba(251, 191, 36, 0.3)',
      cursor: 'pointer',
      zIndex: 30,
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(20px)',
      transition: 'opacity 0.15s ease, transform 0.15s ease', // Transición más rápida (150ms)
      pointerEvents: visible ? 'all' : 'none'
    };
  
    // Estilos de hover
    const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (e.currentTarget) {
        e.currentTarget.style.backgroundColor = '#F59E0B'; // Un tono más oscuro al hacer hover
        e.currentTarget.style.transform = 'translateY(-3px)';
      }
    };
  
    const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (e.currentTarget) {
        e.currentTarget.style.backgroundColor = '#FBBF24';
        e.currentTarget.style.transform = 'translateY(0)';
      }
    };
  
    return (
      <button
        ref={buttonRef}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        aria-label="Volver arriba"
      >
        <ArrowUpIcon size={20} />
      </button>
    );
  };



  const FooterContactSection = () => {
    const itemStyle: React.CSSProperties = {
      display: 'flex',
      gap: '0.75rem',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      borderRadius: '0.5rem',
      padding: '0.35rem 0.5rem',
      fontSize: '0.9rem'
    };
  
    const textStyle: React.CSSProperties = {
      color: '#E5E7EB',
      margin: 0
    };
  
    const hoverStyle = {
      backgroundColor: 'rgba(255, 255, 255, 0.08)'
    };
  


    return (
      <div>
        <h3 style={{
          fontWeight: 'bold',
          color: 'white',
          marginBottom: '1.25rem',
          fontSize: '1.25rem',
          position: 'relative',
          paddingBottom: '0.75rem'
        }}>
          Contacto
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '2rem',
            height: '2px',
            backgroundColor: '#FBBF24'
          }}></div>
        </h3>
  
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <a
  href={`https://www.google.com/maps?q=${encodeURIComponent(direccion)}`}
  target="_blank"
  rel="noopener noreferrer"
  style={itemStyle}
  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
>

            <Home size={18} style={{ color: '#FBBF24' }} />
            <p style={textStyle}>{direccion}</p>
          </a>
  
         <a
         href={`https://wa.me/${telefono.replace(/\D/g, '')}`} // quita símbolos como +
         target="_blank"
         rel="noopener noreferrer"
         style={itemStyle}
         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
       >
         <Phone size={18} style={{ color: '#FBBF24' }} />
         <p style={textStyle}>{telefono}</p>
       </a>
       
       <a
  href={`mailto:${correo}`}
  style={itemStyle}
  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
>
  <Mail size={18} style={{ color: '#FBBF24' }} />
  <p style={textStyle}>{correo}</p>
</a>

  
          {/* <div
            style={itemStyle}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <Clock size={18} style={{ color: '#FBBF24' }} />
            <p style={textStyle}>Lun - Vie: 9:00 - 18:00</p>
          </div> */}
        </div>
  
        {/* Google Maps Embed */}
        <GoogleMapWithLazyLoad direccion={direccion} />

      </div>
    );
  };
  
  const FooterQuickLinksUpdated = () => {
    const scrollToIdWithAnimation = (id: string) => {
      const el = document.getElementById(id);
      if (el) {
        const offsetTop = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    };
  
    return (
      <div>
        <h3 style={{
          fontWeight: 'bold',
          color: 'white',
          marginBottom: '1.25rem',
          fontSize: '1.25rem',
          position: 'relative',
          paddingBottom: '0.75rem'
        }}>
          Enlaces Rápidos
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '2rem',
            height: '2px',
            backgroundColor: '#FBBF24'
          }}></div>
        </h3>
        {[
          { href: '#quienes-somos', label: 'Quienes Somos', icon: <Users size={18} /> },
          { href: '#proyecto-obra-gruesa', label: 'Obra Gruesa', icon: <Building2 size={18} /> },
          { href: '#servicios', label: 'Servicios', icon: <HardHat size={18} /> },
          { href: '#que-es-sip', label: 'Sistema Constructivo', icon: <Layers3 size={18} /> },
          { href: '#contacto', label: 'Contacto', icon: <Mail size={18} /> }
        ].map((item, index) => (
          <a 
            key={index}
            href={item.href}
            onClick={(e) => {
              e.preventDefault();
              scrollToIdWithAnimation(item.href.substring(1));
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              color: '#E5E7EB',
              marginBottom: '0.75rem',
              textDecoration: 'none',
              transition: 'all 0.3s',
              padding: '0.5rem 0.75rem',
              borderRadius: '0.375rem',
              marginLeft: '-0.75rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'translateX(0.25rem)';
              e.currentTarget.style.color = '#FBBF24';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'translateX(0)';
              e.currentTarget.style.color = '#E5E7EB';
            }}
          >
            <span style={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#FBBF24'
            }}>{item.icon}</span>
            <span>{item.label}</span>
          </a>
        ))}
      </div>
    );
  };
  
  // 3. Reemplazo de emojis por iconos de Lucide para el footer - redes sociales
  const FooterSocialIcons = () => {
    const socialLinks = [
      { icon: <WhatsAppIcon size={20} color="#FFFFFF" />, href: `https://wa.me/${telefono.replace(/\D/g, '')}` },
      { icon: <Phone size={20} />, href: `tel:${telefono}` },
    ];
  
    return (
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          marginTop: '4.5rem'
        }}
      >
        {socialLinks.map((social, index) => (
        <a
        key={index}
        href={social.href}
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
      >
        {social.icon}
      </a>
        ))}
      </div>
    );
  };

  const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('hero');
    const [isContactOpen, setContactOpen] = useState(false);
  
    const scrollToId = (id: string) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(id);
        setMobileMenuOpen(false);
      }
    };
  
    return (
      <>
      <style>{`
        /* Estilos para cualquier dispositivo móvil - Prioridad alta */
        @media (max-width: 1024px) {
          #main-header .desktop-nav {
            display: none !important;
          }
          
          #main-header .desktop-quote-btn {
            display: none !important;
          }
          
          #main-header .mobile-menu-btn {
            display: block !important;
            position: relative !important;
            z-index: 51 !important;
          }
          
          #main-header .mobile-placeholder {
            display: block !important;
          }
          
          #mobile-menu {
            display: flex !important;
          }
        }
  
        /* Estilos específicos para móvil vertical */
        @media (max-width: 768px) and (orientation: portrait) {
          #main-header {
            padding: 0.5rem 1rem !important;
            justify-content: space-between !important;
            height: 60px !important;
          }
          
          #main-header .logo-container {
            position: absolute !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            width: 10rem !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          #mobile-menu {
            top: 60px !important;
          }
          
          #main-header .mobile-placeholder {
            width: 40px !important;
          }
        }
  
        /* Estilos específicos para móvil horizontal (landscape) */
        @media (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          #main-header {
            padding: 0.375rem 1rem !important;
            justify-content: space-between !important;
            height: 40px !important;
            background: rgba(0, 0, 0, 0.98) !important;
          }
          
          #main-header .mobile-menu-btn {
            padding: 0.25rem !important;
            font-size: 1.125rem !important;
          }
          
          #main-header .logo-container {
            position: absolute !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            width: 7rem !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          #main-header .logo-container img {
            width: 7rem !important;
            height: auto !important;
            max-height: 28px !important;
          }
          
          #mobile-menu {
            top: 40px !important;
            max-height: calc(100vh - 40px) !important;
            overflow-y: auto !important;
            background: rgba(0, 0, 0, 0.98) !important;
            padding: 0.75rem !important;
            gap: 0.375rem !important;
          }
          
          #mobile-menu button {
            padding: 0.5rem 0.75rem !important;
            font-size: 0.9rem !important;
          }
          
          #mobile-menu .mobile-quote-btn {
            padding: 0.5rem !important;
            margin-top: 0.25rem !important;
          }
          
          #main-header .mobile-placeholder {
            width: 32px !important;
          }
        }
  
        /* Estilos para tablet horizontal - Solo cuando es mayor a 1024px */
        @media (min-width: 1025px) and (max-width: 1200px) and (orientation: landscape) {
          #main-header {
            padding: 0.5rem 1.5rem !important;
            height: 50px !important;
          }
          
          #main-header .logo-container img {
            width: 9rem !important;
          }
          
          #main-header .desktop-nav {
            gap: 1rem !important;
          }
          
          #main-header .desktop-nav button {
            padding: 0.375rem 0.5rem !important;
            font-size: 0.9rem !important;
          }
        }
        
        /* Estilos para escritorio - Solo pantallas grandes */
        @media (min-width: 1025px) {
          #main-header .mobile-menu-btn {
            display: none !important;
          }
          
          #mobile-menu {
            display: none !important;
          }
          
          #main-header .mobile-placeholder {
            display: none !important;
          }
          
          #main-header .desktop-nav {
            display: flex !important;
          }
          
          #main-header .desktop-quote-btn {
            display: block !important;
          }
        }
  
        /* Animaciones suaves */
        #main-header {
          transition: all 0.3s ease !important;
        }
        
        #mobile-menu {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
      `}</style>
  
        <header id="main-header" style={{
          width: '100%',
          padding: '1rem 2rem',
          background: 'rgba(0, 0, 0, 0.95)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 50,
          color: 'white',
          transition: 'all 0.3s ease',
        }}>
          {/* Botón de menú móvil */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0.5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '0.25rem',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
  
          {/* Placeholder para balance en móvil */}
          <div className="mobile-placeholder" style={{ display: 'none' }}></div>
  
          {/* Logo centrado */}
          <div className="logo-container" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            cursor: 'pointer',
          }} onClick={() => scrollToId('hero')}>
            <img 
              src={logo} 
              alt="Logo" 
              style={{ 
                width: '10rem',
                objectFit: 'contain',
                display: 'block',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            />
          </div>
  
          {/* Navegación de escritorio */}
          <nav className="desktop-nav" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1.5rem',
            flex: 1,
            justifyContent: 'flex-start',
          }}>
            {[
              { id: 'quienes-somos', label: 'Quiénes Somos' }, 
              { id: 'proyecto-obra-gruesa', label: 'Obra gruesa' },
              { id: 'servicios', label: 'Servicios' },  
  
               
              { id: 'contacto', label: 'Contacto' }
            ].map(item => (
              <button 
                key={item.id}
                onClick={() => scrollToId(item.id)}
                style={{
                  background: activeSection === item.id ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '0.5rem 0.75rem',
                  borderRadius: '0.375rem',
                  fontSize: '1rem',
                  transition: 'all 0.3s',
                  fontWeight: activeSection === item.id ? 'bold' : 'normal',
                  position: 'relative',
                  transform: 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  if (activeSection !== item.id) {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeSection !== item.id) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }
                }}
              >
                {item.label}
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  height: '2px',
                  width: activeSection === item.id ? '80%' : '0%',
                  backgroundColor: '#FBBF24',
                  transition: 'width 0.3s ease'
                }} />
              </button>
            ))}
          </nav>
  
          {/* Botón de cotización de escritorio */}
          <div className="desktop-quote-btn" style={{
            marginLeft: 'auto',
            paddingRight: '50px',
          }}>
            <BotonCotizar setContactOpen={() => setContactOpen(true)} />
          </div>
        </header>
  
        {/* Menú móvil mejorado */}
        <div id="mobile-menu" style={{
          display: 'none',
          position: 'fixed',
          top: '60px',
          left: 0,
          right: 0,
          background: 'rgba(0, 0, 0, 0.95)',
          backdropFilter: 'blur(10px)',
          flexDirection: 'column',
          padding: '1rem',
          gap: '0.5rem',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
          transform: mobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
          opacity: mobileMenuOpen ? 1 : 0,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          zIndex: 40,
          maxHeight: 'calc(100vh - 60px)',
          overflowY: 'auto'
        }}>
          {[
            { id: 'quienes-somos', label: 'Quiénes Somos' },
            { id: 'servicios', label: 'Servicios' },
            { id: 'valores', label: 'Valores' },
            { id: 'contacto', label: 'Contacto' }
          ].map(item => (
            <button 
              key={item.id}
              onClick={() => scrollToId(item.id)}
              style={{
                background: activeSection === item.id ? 'rgba(251, 191, 36, 0.2)' : 'transparent',
                border: activeSection === item.id ? '1px solid rgba(251, 191, 36, 0.3)' : '1px solid transparent',
                color: 'white',
                cursor: 'pointer',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'left',
                display: 'block',
                width: '100%',
                transition: 'all 0.3s ease',
                fontWeight: activeSection === item.id ? '600' : 'normal'
              }}
              onMouseEnter={(e) => {
                if (activeSection !== item.id) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (activeSection !== item.id) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.borderColor = 'transparent';
                }
              }}
            >
              {item.label}
            </button>
          ))}
          
          <button 
            className="mobile-quote-btn"
            style={{
              backgroundColor: '#FBBF24',
              color: '#1A1A1A',
              padding: '0.75rem',
              borderRadius: '0.5rem',
              fontWeight: 'bold',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              marginTop: '0.5rem',
              width: '100%',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 10px rgba(251, 191, 36, 0.3)'
            }} 
            onClick={() => {
              setContactOpen(true);
              setMobileMenuOpen(false);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#F59E0B';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(251, 191, 36, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FBBF24';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(251, 191, 36, 0.3)';
            }}
          >
            <LucideMail size={18} /> Cotiza con nosotros
          </button>
        </div>
  
        {/* Overlay para cerrar menú móvil */}
        {mobileMenuOpen && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.3)',
              zIndex: 35,
              backdropFilter: 'blur(2px)'
            }}
            onClick={() => setMobileMenuOpen(false)}
          />
        )}
  
        <ContactModal 
          isOpen={isContactOpen} 
          onClose={() => setContactOpen(false)} 
          telefono={telefono}
        />

<FloatingWhatsApp />

      </>
    );
  };
  const scrollToId = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id);
      setMobileMenuOpen(false);
    }
  };

  // Observador de intersección para actualizar el menú activo al hacer scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6 }
    );

    document.querySelectorAll('section[id]').forEach((section) => {
      observer.observe(section);
    });

    return () => {
      document.querySelectorAll('section[id]').forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  // Autocarrusel para la galería
  useEffect(() => {
    const interval = setInterval(() => {
      if (carouselRef.current) {
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth - carouselRef.current.clientWidth - 10) {
          carouselRef.current.scrollLeft = 0;
        } else {
          carouselRef.current.scrollLeft += 320;
        }
      }
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, sans-serif',
      background: 'linear-gradient(135deg, #F5F5F5 0%, #E0E0E0   100%)',
      color: '#334155',
      overflowX: 'hidden'
    }}>
      {/* Header */}
<Header/>
      {/* Mobile Menu */}
      <div style={{
        position: 'fixed',
        top: '70px',
        left: 0,
        right: 0,
        background: 'rgba(30, 64, 175, 0.95)',
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        gap: '0.5rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        transform: mobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
        opacity: mobileMenuOpen ? 1 : 0,
        transition: 'all 0.3s ease',
        zIndex: 40
      }}>
        {[
          { id: 'quienes-somos', label: 'Quiénes Somos', icon: '👥' },
          { id: 'que-es-sip', label: '¿Qué es un SIP?', icon: '🔍' },
          { id: 'galeria', label: 'Galería', icon: '🖼️' },
          { id: 'servicios', label: 'Servicios', icon: '🛠️' },
          { id: 'contacto', label: 'Contacto', icon: '📧' }
        ].map(item => (
          <button 
            key={item.id}
            onClick={() => scrollToId(item.id)}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: '0.75rem',
              borderRadius: '0.375rem',
              fontSize: '1rem',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}
          >
            <span>{item.icon}</span> {item.label}
          </button>
        ))}
        
        <button style={{
          backgroundColor: '#FBBF24',
          color: '#F0F0F0',
          padding: '0.75rem',
          borderRadius: '0.375rem',
          fontWeight: 'bold',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          marginTop: '0.5rem'
        }} onClick={() => setContactOpen(true)}>
          <Phone size={18} /> Llámanos
        </button>
      </div>

      <main style={{ paddingTop: '70px' }}>
        {/* Hero Section con Carrusel */}
<HeroCarousel></HeroCarousel>
{/* Sección Quiénes Somos */}
<QuienesSomosSection/>
<ProyectoObraGruesaSection/>
        {/* Servicios */}
        <ServiciosSection></ServiciosSection>
        
        {/* ¿Qué es un SIP? */}
    <section id="que-es-sip" style={{
  position: 'relative'
}}>
 <SistemaConstruccion/>
</section>


{/* <ValoresSection/> */}
 <ContactoSection/>

        {/* Galería */}
{/* <GaleriaProyectos></GaleriaProyectos> */}


        {/* Newsletter */}
        {/* <section id="contacto" style={{
          padding: '4rem 2rem',
          background: 'linear-gradient(135deg, #F0F0F0 0%, #FEF3C7 100%)',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '2.25rem',
            fontWeight: 'bold',
            color: '#000000',
            marginBottom: '1.5rem'
          }}>
            Suscríbete a nuestro boletín
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: '#4B5563',
            maxWidth: '42rem',
            margin: '0 auto 2rem'
          }}>
            Recibe noticias, lanzamientos y consejos sobre construcción eficiente directamente en tu bandeja de entrada.
          </p>
          
          <div style={{
            display: 'flex',
            maxWidth: '500px',
            margin: '0 auto',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: '2rem',
            overflow: 'hidden',
            flexDirection: typeof window !== 'undefined' && window.innerWidth > 640 ? 'row' : 'column'
          }}>
            <input 
              type="email" 
              placeholder="Tu correo electrónico" 
              style={{
                flex: 1,
                padding: '1rem 1.5rem',
                border: 'none',
                outline: 'none',
                fontSize: '1rem',
                borderRadius: typeof window !== 'undefined' && window.innerWidth <= 640 ? '1rem 1rem 0 0' : '2rem 0 0 2rem'
              }}
            />
<button className="btn-suscribirse">
  Suscribirse
</button>

          </div>
          
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2rem',
            flexWrap: 'wrap',
            marginTop: '3rem'
          }}>
            {/* <a href="tel:+56912345678" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              color: '#000000',
              textDecoration: 'none',
              fontWeight: '500',
              padding: '0.75rem 1.25rem',
              backgroundColor: 'white',
              borderRadius: '2rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              transition: 'all 0.3s'
            }}>
              <Phone size={20} />
              <span>+56 9 1234 5678</span>
            </a>
            
            <a href="mailto:contacto@enprotec.cl" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              color: '#000000',
              textDecoration: 'none',
              fontWeight: '500',
              padding: '0.75rem 1.25rem',
              backgroundColor: 'white',
              borderRadius: '2rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              transition: 'all 0.3s'
            }}>
              <Mail size={20} />
              <span>contacto@enprotec.cl</span>
            </a> */}
          {/*</div>*/}
        {/*</section>*/}
      </main>

     {/* Footer */}
     <footer style={{
        //backgroundColor: '#F0F0F0',
        backgroundColor: '#000000',
        color: '#E5E7EB',
        padding: '4rem 2rem 2rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fit, minmax(200px, 1fr))`,
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div>
          <div style={{
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  left: '30',  // Alineación a la izquierda
  cursor: 'pointer',
}} onClick={() => scrollToId('hero')}>
  <img 
    src={logo} 
    alt="Logo" 
    style={{ 
      width: '12rem',
      objectFit: 'contain',
      display: 'block',
      transition: 'transform 0.3s ease'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.1)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
    }}
  />
</div>

            {/* <p style={{ marginBottom: '1.5rem', marginTop:'2.0rem' }}>Soluciones innovadoras para la construcción moderna con paneles SIP de alta calidad.</p> */}
<FooterSocialIcons></FooterSocialIcons>
          </div>
          
        <FooterQuickLinksUpdated/>
          
      <FooterContactSection></FooterContactSection>
{/*           
          <div>
            <h3 style={{
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '1.25rem',
              fontSize: '1.25rem',
              position: 'relative',
              paddingBottom: '0.75rem'
            }}>
              Boletín
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '2rem',
                height: '2px',
                backgroundColor: '#FBBF24'
              }}></div>
            </h3>
            <p style={{ marginBottom: '1rem' }}>Suscríbete para recibir las últimas novedades y ofertas especiales.</p>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}>
              <input 
  type="email" 
  placeholder="Tu email" 
  style={{
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    border: '1px solid #cbd5e1',
    backgroundColor: 'white',
    color: '#1f2937',
    outline: 'none',
    width: '100%'
  }}
/>

<button className="btn-yellow-subscribe">
  Suscribirse
</button>

            </div>
          </div> */}
        </div>
        
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          margin: '2rem 0'
        }}></div>
        
        <div style={{
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '0.875rem'
        }}>
          © {new Date().getFullYear()} ENPROTEC. Todos los derechos reservados.
        </div>
      </footer>

      {/* Botón Scroll to Top */}
  {showScrollTop && (
  <ScrollToTopButton />



)}


<ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setContactOpen(false)} 
        telefono={telefono}
      />
          </div>
  );
};

export default LandingPage;
